// IntegrationsSections.tsx · v12.10.31 (#2314 an action's answer can hold a LIST - list path + item fields picked from the sample, kind slots / patients / other) · 2026-11-05 · VoiceSpectrum AI
// IntegrationsSections.tsx · v12.10.28 (#2209 Translations button per connected system; old {provider.id} / {location.id} named on save) · 2026-11-02 · VoiceSpectrum AI
// IntegrationsSections.tsx · v12.10.11.1 (#1487 Webhooks switch needs an endpoint) · 2026-10-09
// IntegrationsSections.tsx · v12.10.10 (#1406 C6: an action body that sends {entity.id} from a field not tied to a list is named on save) · 2026-10-08 · VoiceSpectrum AI
// IntegrationsSections.tsx · v12.10.9.4 (#1357 US spelling) · 2026-10-07 · VoiceSpectrum AI
// IntegrationsSections.tsx - v12.9.24 (#921): a \u2192 escape in JSX text rendered literally; now the character. Found by Check-JsxTextEscapes_v1.0.
// IntegrationsSections.tsx - v12.5.3
// v12.5.3 (#542/#543/#544): a JSON body's U+00A0 indentation no longer blocks the save (normalizeBodyWhitespace,
// and the SAVE stores the cleaned body); the drawer's Run test sends CANONICAL samples so a chosen wire format
// actually applies and the test matches a live call; and every request field is one line - Label, Field, Type,
// Format, Value sent - with the type read-only from the vocabulary and the unchanged option named in plain words.
// IntegrationsSections.tsx — v12.4.16
// v12.4.16 (#515): Retry attempts now says what it MEANS against the call, and so does the Action timeout on
// the Reliability screen. The two settings that decide how long a caller can be held live on two different
// screens and neither showed the combined effect - Tushar could set 6s x 3 in perfect good faith and see
// nothing. Both screens now compute the same total from lib/holdBudget.ts (a mirror of
// ConnectHoldStore.BudgetFor) and say plainly when it is clamped to the 60s ceiling. The engine half of #515
// took integration work out of the Twilio turn, so this is no longer "how soon does the call drop" but "how
// long is a caller held". No new setting, no default changed.
// v12.4.16 (#495): the test's Sample values panel lists EVERY field the request body sends, not only the token
// ones. His words, 2026-09-19: "i wiped out values for Gender, Doctor, location etc.. and then i added values but
// now in the test fields those values are not coming." Nothing was dropped - the sent body carried them and PMWeb
// accepted them - but a panel that can only show tokens reads as if the literals had vanished. Token fields stay
// editable, literals are shown read-only and tagged, and the order is the body's own so nothing jumps as he types.
// v12.4.16 (#498): the `response.` display prefix on THEIR side of a mapping is replaced by "Their field" /
//                   "Our token" column headers; our side is now the external.* family.
// v12.4.16 (#497): the action editor now reads request → test → response. The test FEEDS the Response block
// ("Use the last test response"), so it sat after the thing it fills; it is above it now.
// v12.4.14 (#85a): every action gains a RESPONSE block - paste a sample answer, then pick from its fields
// rather than typing paths. It names the field that decides success (PMWeb answers HTTP 200 with
// {"status": false}, so HTTP alone would let the agent confirm a booking that never happened), what that
// field's values MEAN, and which parts of the answer are kept as our tokens. Stored on the action inside
// ActionsJson as response:{sample,resultField,successValues,failureValues,map:[{path,token}]} - the API passes
// the actions array through as opaque JSON, so this needed no API change. Read by IntegrationCatalog.ParseActions.
// v12.4.14 (#488): the Run test button used the footer-only .ma class and rendered unstyled; it is .btn-soft.is-primary now.
// v12.4.13 (#486/#485/#483): the separate Test connection drawer is GONE, and with it the stray URL box that
// invited a third address the saved connection never used (#485 - Token URL and Base URL are the two addresses;
// an action path may itself be a full URL when one action lives elsewhere). The card now carries a Check
// Connection control in the T4 Provider Registry style, and the TESTS LIVE BESIDE THE FIELDS THEY EXERCISE: one
// on the OAuth block that fetches a token, one on every action that fetches the token and then calls that action.
// Every test runs against WHAT IS ON SCREEN - Tushar, 2026-09-18: "this will allow just to test connection, or
// change connection and test before saving in db (new or edit existing)" - so only Save writes to the database.
// The client_secret is the exception: left blank it means the stored one.
// The card's Enabled toggle no longer posts blank OAuth fields (with #483's keep rule, omitting them keeps them).
// v12.4.12 (#482): OAuth 2.0 client credentials. With Auth method = OAuth 2.0 the drawer shows Token URL,
// grant_type, client_id, client_secret (the connection's one write-only secret) and scope. Each action gets its
// own Content-Type. The action path and body use the shared TokenPicker with the CANONICAL vocabulary and the
// tenant's labels - the old identity-identifier chips ({member_id}, {date_of_birth}) are gone. Test connection
// picks an action, fetches the OAuth token itself (no hand-typed token), fills the action's tokens from editable
// sample values, and shows the token result separately from the action's result.
// v12.2.23.0 (#150): connected-system actions with a POST/PUT/PATCH method now get a request-body textarea
// (JSON) composed with captured-value tokens ({member_id}, {date_of_birth}, …). The body persists on the
// action (in ActionsJson) and is what the Connect node posts when integrations fire.
// v12.2.21.0 (INT-TEST): Connected systems gain a live "Test connection" (REST/FHIR) — a drawer to pick a
// method + path, enter a token (sent as a request HEADER, never the URL) and a dummy JSON body, fire a real
// request, and see the HTTP status + response. Nothing entered here is persisted. Backend:
// POST /t2/settings/integrations/connected-systems/{id}/test.
// v12.1.26.0: added help tooltips (3-part What it does / When it fires / Example) to the Webhooks +
//   Connected-systems section headers, the webhook master toggle, and every field in both drawers
//   (endpoint + connected-system, incl. REST/FHIR/HL7/SFTP + secret + actions). The 5 failure-policy
//   tooltips are unchanged. No logic/API/DB change.
// T2 Settings › Integrations area (3 sections): Webhooks · Connected systems · Failure policy.
// Ported for fidelity from integrations_only_v1_1.html against the already-built
// IntegrationsController API.
//
// APPLY MODEL (per the KB "documents apply immediately vs retrieval is save-gated" pattern):
//  • Webhooks and Connected systems are CARD GRIDS — add/edit/delete hit the API immediately via
//    the drawer's Save (each mutation returns the FULL IntegrationsDto, which re-seeds local state).
//    "Send test event" per endpoint likewise fires immediately.
//  • The scalar forms are SAVE-GATED per section: the Webhooks master-enable toggle (section key
//    'webhooks') and the whole Failure policy block (section key 'failure') both persist via
//    PUT /settings and enable Save/Discard only when that section is dirty.
// Per-section dirty + saveAll/discardAll are reported up to the Settings shell (mirrors
// CallHandlingSections / PersonalizationSections).
//
// SECRETS (§C1): webhook authValue and connected-system secret are masked password inputs with a
// reveal toggle. When hasAuth/hasSecret is true the field DEFAULTS EMPTY with a "Saved — leave
// blank to keep" placeholder and we send the keep-sentinel "****" on save so the API preserves the
// stored secret; the stored secret is NEVER returned to or displayed by the client.
import { ReactNode, useEffect, useRef, useState } from 'react';
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import api from '../lib/api';
// v12.4.16 (#515): ONE copy of ConnectHoldStore.BudgetFor's arithmetic, shared with Settings › Reliability.
import { holdBudget, holdOutcome, holdSeconds, holdWorking, HOLD_DEFAULT_ACTION_TIMEOUT_MS } from '../lib/holdBudget';
import { HelpTooltip } from '../components/aiagent/HelpTooltip';
// v12.4.12 (#482): the canonical vocabulary picker, the tenant's labels, and the design-time sample values.
import { TokenPicker, TOKEN_GROUPS } from '../components/aiagent/TokenPicker';
import { useVocabulary, catalogGroups, tokenLabel, makeAliasOf, canonToken } from '../components/PromptEditor';
import { SAMPLE_VALUES, WIRE_SAMPLE_VALUES, CANONICAL_SAMPLE_BY_TYPE } from '../lib/tokenPreview';
import './settings-controls.css';
import './ai-agent.css';   // v12.4.12 (#482): TokenPicker's styles are scoped under .ai-agent-panel
import './integrations.css';
import { TranslationsDrawer } from './integrations/TranslationsDrawer';   // v12.10.28 (#2209)

/* ── API DTO shapes (camelCase; the API defaults camelCase) ─────────────── */
export interface IntWebhook {
  id: string; name: string; url: string; authHeader: string; hasAuth: boolean;
  events: string[]; enabled: boolean;
}
export interface IntConnectedSystem {
  id: string; name: string; type: string; authMethod: string; hasSecret: boolean;
  baseUrl: string; fhirVersion: string; config: Record<string, unknown>;
  actions: IntAction[]; enabled: boolean; status: 'configured' | 'not_configured';
  // v12.4.12 (#482): OAuth 2.0 client credentials (client_secret is never returned - hasSecret says it is saved)
  oauthTokenUrl?: string | null; oauthGrantType?: string | null; oauthClientId?: string | null; oauthScope?: string | null;
}
// v12.5.2 (#496): `formats` is token key -> .NET format string, e.g. { "subject.dob": "yyyy-MM-dd HH:mm:ss.fff" }.
// PER FIELD, on the ACTION - because PM Web's saveAppointment wants dob as "yyyy-MM-dd HH:mm:ss.fff" and
// visitDate as "yyyy-MM-dd" in the SAME request, and CheckPatientExists wants that same dob as "MM/dd/yyyy".
// A per-integration or per-type setting cannot express that. Absent => today's output, unchanged.
export interface IntAction { name: string; method: string; path: string; desc: string; body?: string; contentType?: string; formats?: Record<string, string>; response?: IntActionResponse; lastTest?: IntActionLastTest }
// v12.4.15 (#492): the outcome of the last test, kept on the action so the pill can say so after a reopen.
// `fp` is a fingerprint of WHAT WAS TESTED - method, path, Content-Type, body and the result rule. When the action
// no longer matches it, the badge reads 'tested · since edited' rather than a green OK, because a stored pass next
// to an edited request is the same confident-wrong-answer shape as #489.
export interface IntActionLastTest { at: string; ok: boolean; status: number; fp: string }
// v12.4.14 (#85a): one mapping row - a path into THEIR answer, bound to one of OUR canonical tokens.
export interface IntActionResponseMap { path: string; token: string }
// successValues / failureValues are kept as the tenant typed them (comma-separated); the engine's
// IntegrationCatalog accepts either that or a JSON array, so nothing is lost either way.
export interface IntActionResponse {
  sample?: string; resultField?: string; successValues?: string; failureValues?: string; map?: IntActionResponseMap[];
  // v12.10.31 (#2314): the answer holds a list (up to 5 slots / patients). Absent = a single answer, as today.
  list?: IntActionResponseList | null;
}
export interface IntActionResponseList { path: string; kind: 'slots' | 'patients' | 'other'; fields: { date?: string; time?: string; label?: string; id?: string } }

/** v12.10.31 (#2314): the arrays in a sample answer ("data.slots") and the field names of their first item. */
function sampleArrays(json: string): Array<{ path: string; itemFields: string[] }> {
  let root: unknown;
  try { root = JSON.parse(json); } catch { return []; }
  const out: Array<{ path: string; itemFields: string[] }> = [];
  const walk = (node: unknown, prefix: string, depth: number) => {
    if (node === null || typeof node !== 'object' || depth > 4 || out.length > 20) return;
    if (Array.isArray(node)) {
      const first = node[0];
      const fields = first && typeof first === 'object' && !Array.isArray(first) ? Object.keys(first as Record<string, unknown>) : [];
      out.push({ path: prefix || '(the whole answer)', itemFields: fields });
      return;
    }
    for (const [k, v] of Object.entries(node as Record<string, unknown>)) walk(v, prefix ? `${prefix}.${k}` : k, depth + 1);
  };
  walk(root, '', 0);
  return out;
}
export interface IntFailurePolicy {
  webhookRetryPolicy: string; webhookOnFinalFailure: string; webhookAlertEmail: string;
  csRetryAttempts: number; csCallerFallback: string; csSpokenLine: string;
  // v12.7.1 (#590 / BDR-014): the connected-system action timeout, which this screen now OWNS.
  // null = not set here; the engine then falls back exactly as it did before the split.
  csActionTimeoutMs: number | null;
}
export interface IntegrationsData {
  webhooksEnabled: boolean;
  webhooks: IntWebhook[];
  connectedSystems: IntConnectedSystem[];
  failurePolicy: IntFailurePolicy;
  eventCatalog: string[];
}

/* ── shell-reporting types ──────────────────────────────────────────────── */
// Only the SAVE-GATED scalar sections carry a dirty flag. The card-grid CRUD applies immediately.
export type IntSectionKey = 'webhooks' | 'failure';
export type IntDirtyMap = Record<IntSectionKey, boolean>;
export interface IntegrationsState { dirty: IntDirtyMap; anyDirty: boolean; saveAll: () => void; discardAll: () => void; }

const QKEY = ['t2-integrations'];
// Keep-sentinel: sent for a secret field the user left blank when a secret is already stored, so the
// API keeps the stored value rather than clearing it.
const SECRET_KEEP = '****';

// Descriptions for the 7-event catalog (from the prototype). Falls back to '' for unknown keys.
const EVENT_DESC: Record<string, string> = {
  'call.started': 'When a call begins',
  'call.ended': 'When a call completes',
  'call.handoff': 'When a call is handed to a human',
  'call.voicemail': 'When a voicemail is captured',
  'identity.captured': 'When the caller is identified',
  'kb.answered': 'When the AI answers from the knowledge base',
  'error': 'When the engine raises an error',
};

const CONN_TYPES: [string, string][] = [['rest', 'REST API'], ['fhir', 'FHIR'], ['hl7', 'HL7 v2'], ['sftp', 'SFTP']];
const CONN_AUTH: [string, string][] = [['bearer', 'Bearer token'], ['apikey', 'API key header'], ['basic', 'Basic auth'], ['oauth2', 'OAuth 2.0 client credentials'], ['none', 'None']];
// ── v12.6.1 (#545): THE SELECT NOW STORES A KEY, NOT ITS OWN LABEL. ────────────────────────────────
//
// `webhook_retry_policy` is nvarchar(32) and the entity's comment says "preset name". This select was
// posting the visible text, and two of these four labels are 48 and 59 characters - so on SQL Server **two
// of the four options could not be saved at all**, and the two that could were stored as prose that would
// change the day someone improved the wording.
//
// Same shape as every other select on this screen (CONN_TYPES, CONN_AUTH, WEBHOOK_FINAL) - this one was the
// outlier. The API normalises on read as well as write, so a tenant whose row holds a truncated label still
// renders the right option instead of a blank select.
const WEBHOOK_RETRY: [string, string][] = [
  ['standard',     '3 retries · exponential backoff (30s / 2m / 10m)'],
  ['extended',     '5 retries · exponential backoff (30s / 2m / 10m / 30m / 2h)'],
  ['single_retry', '1 retry · after 60s'],
  ['none',         'None — single attempt only'],
];

// A row written before 12.6.1 holds a label, possibly cut off mid-word at 32 characters. Mirrors
// IntegrationsSettingsController.NormalizeRetryPolicy - the API is authoritative, this keeps the select from
// flashing blank on the way there.
function normalizeRetryPolicy(stored: string | undefined | null): string {
  const v = (stored ?? '').trim();
  if (!v) return 'standard';
  if (WEBHOOK_RETRY.some(([k]) => k === v)) return v;
  if (/^3 retries/i.test(v)) return 'standard';
  if (/^5 retries/i.test(v)) return 'extended';
  if (/^1 retry/i.test(v)) return 'single_retry';
  if (/^None/i.test(v)) return 'none';
  return 'standard';
}
const WEBHOOK_FINAL: [string, string][] = [['queue', 'Queue for manual replay'], ['drop_alert', 'Drop and alert admin'], ['drop_silent', 'Drop silently']];
const CS_RETRY: [number, string][] = [[1, '1 retry, then fall back'], [2, '2 retries, then fall back'], [0, 'No retry — fall back immediately']];
const CS_FALLBACK: [string, string][] = [
  ['take_message', 'Take a message & log a follow-up'],
  ['handoff', 'Hand off to staff'],
  ['continue', 'Continue without the lookup'],
  ['voicemail', 'Route to voicemail'],
];

const connTypeLabel = (t: string) => CONN_TYPES.find((x) => x[0] === t)?.[1] ?? t;
const connAuthLabel = (a: string) => CONN_AUTH.find((x) => x[0] === a)?.[1] ?? a;
const connUsesActions = (t: string) => t === 'rest' || t === 'fhir';

/* ─────────────────────────────────────────────────────────────────────── */
export default function IntegrationsSections({ onStateChange }: { onStateChange?: (s: IntegrationsState) => void } = {}) {
  const queryClient = useQueryClient();
  const { data, isLoading, error } = useQuery<IntegrationsData>({
    queryKey: QKEY,
    queryFn: () => api.get<IntegrationsData>('/t2/settings/integrations'),
  });

  // v12.7.1 (#590 / BDR-014): THE CROSS-SCREEN READ IS GONE. This used to fetch `/t2/settings/reliability`
  // for the other half of the hold budget, which is precisely the two-screens-for-one-decision that BDR-014
  // §7 says must come out - and after 12.7.0 it was worse than untidy, because the engine had stopped using
  // that number while this screen went on displaying a budget computed from it. Both inputs are now this
  // screen's own, so the arithmetic shown here is the arithmetic the call performs.

  // save-gated scalar drafts: webhook master-enable + the whole failure policy
  const [savedEnabled, setSavedEnabled] = useState<boolean | null>(null);
  const [draftEnabled, setDraftEnabled] = useState<boolean | null>(null);
  const [savedFp, setSavedFp] = useState<IntFailurePolicy | null>(null);
  const [draftFp, setDraftFp] = useState<IntFailurePolicy | null>(null);

  const [hookDrawer, setHookDrawer] = useState<{ index: number | null } | null>(null);
  const [connDrawer, setConnDrawer] = useState<{ index: number | null } | null>(null);
  const [trFor, setTrFor] = useState<{ id: string; name: string } | null>(null);   // v12.10.28 (#2209): Translations drawer
  // v12.4.13 (#486): per-card Check Connection result, keyed by connection id. The card reflects what is SAVED,
  // so this check sends no on-screen overrides - the server falls back to the stored row.
  const [checks, setChecks] = useState<Record<string, TestResult | 'pending'>>({});
  const [toast, setToast] = useState('');
  const toastTimer = useRef<number | undefined>(undefined);
  function showToast(m: string) { if (toastTimer.current) window.clearTimeout(toastTimer.current); setToast(m); toastTimer.current = window.setTimeout(() => setToast(''), 3200); }
  useEffect(() => () => window.clearTimeout(toastTimer.current), []);

  useEffect(() => {
    if (!data) return;
    setSavedEnabled(data.webhooksEnabled);
    setDraftEnabled(data.webhooksEnabled);
    setSavedFp(structuredClone(data.failurePolicy));
    setDraftFp(structuredClone(data.failurePolicy));
  }, [data]);

  // Every mutation returns the full IntegrationsDto — re-seed cache + the save-gated drafts.
  function reseed(fresh: IntegrationsData) {
    queryClient.setQueryData(QKEY, fresh);
    setSavedEnabled(fresh.webhooksEnabled); setDraftEnabled(fresh.webhooksEnabled);
    setSavedFp(structuredClone(fresh.failurePolicy)); setDraftFp(structuredClone(fresh.failurePolicy));
  }

  // ── save-gated settings PUT (master toggle + failure policy) ──
  const saveSettings = useMutation({
    mutationFn: (v: { webhooksEnabled: boolean; fp: IntFailurePolicy }) => api.put<IntegrationsData>('/t2/settings/integrations/settings', {
      webhooksEnabled: v.webhooksEnabled,
      webhookRetryPolicy: v.fp.webhookRetryPolicy,
      webhookOnFinalFailure: v.fp.webhookOnFinalFailure,
      webhookAlertEmail: v.fp.webhookAlertEmail,
      csRetryAttempts: v.fp.csRetryAttempts,
      csActionTimeoutMs: v.fp.csActionTimeoutMs,   // v12.7.1 (#590)
      csCallerFallback: v.fp.csCallerFallback,
      csSpokenLine: v.fp.csSpokenLine,
    }),
    onSuccess: reseed,
  });

  // ── webhook CRUD (immediate) ──
  const createHook = useMutation({ mutationFn: (b: HookBody) => api.post<IntegrationsData>('/t2/settings/integrations/webhooks', b), onSuccess: (d) => { reseed(d); showToast('Webhook saved.'); } });
  const updateHook = useMutation({ mutationFn: (v: { id: string; body: HookBody }) => api.put<IntegrationsData>(`/t2/settings/integrations/webhooks/${v.id}`, v.body), onSuccess: (d) => { reseed(d); showToast('Webhook saved.'); } });
  const deleteHook = useMutation({ mutationFn: (id: string) => api.delete<IntegrationsData>(`/t2/settings/integrations/webhooks/${id}`), onSuccess: (d) => { reseed(d); showToast('Webhook removed.'); } });
  const testHook = useMutation({
    mutationFn: (id: string) => api.post<{ ok: boolean; status: number; detail: string }>(`/t2/settings/integrations/webhooks/${id}/test`),
    onSuccess: (r) => showToast(r.ok ? `Test event delivered — HTTP ${r.status}. ${r.detail ?? ''}`.trim() : `Test failed — ${r.status ? `HTTP ${r.status}. ` : ''}${r.detail ?? 'Endpoint unreachable.'}`),
    onError: () => showToast('Test failed — the endpoint could not be reached.'),
  });

  // v12.4.13 (#486): the card's Check Connection. OAuth 2.0 -> the server fetches a token; any other auth -> a
  // light GET on the base URL. One control, one line of result, no drawer.
  async function runCheck(c: IntConnectedSystem) {
    setChecks((m) => ({ ...m, [c.id]: 'pending' }));
    try {
      const r = await api.post<TestResult>(`/t2/settings/integrations/connected-systems/${c.id}/test`, { mode: 'check' });
      setChecks((m) => ({ ...m, [c.id]: r }));
    } catch {
      setChecks((m) => ({ ...m, [c.id]: { ok: false, status: 0, detail: 'Check failed — the endpoint could not be reached.' } }));
    }
  }

  // ── connected-system CRUD (immediate) ──
  const createConn = useMutation({ mutationFn: (b: ConnBody) => api.post<IntegrationsData>('/t2/settings/integrations/connected-systems', b), onSuccess: (d) => { reseed(d); showToast('Connection saved.'); } });
  const updateConn = useMutation({ mutationFn: (v: { id: string; body: ConnBody }) => api.put<IntegrationsData>(`/t2/settings/integrations/connected-systems/${v.id}`, v.body), onSuccess: (d) => { reseed(d); showToast('Connection saved.'); } });
  const deleteConn = useMutation({ mutationFn: (id: string) => api.delete<IntegrationsData>(`/t2/settings/integrations/connected-systems/${id}`), onSuccess: (d) => { reseed(d); showToast('Connection removed.'); } });

  const eq = (a: unknown, b: unknown) => JSON.stringify(a) === JSON.stringify(b);
  const webhooksDirty = savedEnabled != null && draftEnabled != null && draftEnabled !== savedEnabled;
  const failureDirty = !!savedFp && !!draftFp && !eq(draftFp, savedFp);

  // Report per-section dirty + save/discard-all up to the Settings shell.
  const reportRef = useRef(onStateChange); reportRef.current = onStateChange;
  useEffect(() => {
    if (!reportRef.current || draftEnabled == null || !draftFp) return;
    const dirty: IntDirtyMap = { webhooks: webhooksDirty, failure: failureDirty };
    reportRef.current({
      dirty,
      anyDirty: webhooksDirty || failureDirty,
      // Both save-gated sections persist through the same PUT /settings; send the current drafts.
      saveAll: async () => { try { if (webhooksDirty || failureDirty) await saveSettings.mutateAsync({ webhooksEnabled: draftEnabled, fp: draftFp }); } catch { /* surfaced by the mutation */ } },
      discardAll: () => { setDraftEnabled(savedEnabled); setDraftFp(savedFp ? structuredClone(savedFp) : draftFp); },
    });
  }, [webhooksDirty, failureDirty, draftEnabled, draftFp]); // eslint-disable-line react-hooks/exhaustive-deps

  if (isLoading || !data || draftEnabled == null || !draftFp) return <div className="settings-loading">Loading Integrations settings…</div>;
  if (error) return <div className="settings-error">Integrations settings could not be loaded.</div>;

  const patchFp = (p: Partial<IntFailurePolicy>) => setDraftFp((f) => (f ? { ...f, ...p } : f));
  const eventCatalog = data.eventCatalog?.length ? data.eventCatalog : Object.keys(EVENT_DESC);

  // Per-card enable toggles apply IMMEDIATELY via the existing update endpoint. The secret is kept by
  // sending the keep-sentinel so flipping enable never disturbs the stored credential (§C1).
  const toggleHookEnabled = (h: IntWebhook) => updateHook.mutate({ id: h.id, body: { name: h.name, url: h.url, authHeader: h.authHeader, authValue: h.hasAuth ? SECRET_KEEP : '', events: h.events, enabled: !h.enabled } });
  const toggleConnEnabled = (c: IntConnectedSystem) => updateConn.mutate({ id: c.id, body: { name: c.name, type: c.type, authMethod: c.authMethod, secret: c.hasSecret ? SECRET_KEEP : '', baseUrl: c.baseUrl, fhirVersion: c.fhirVersion, config: c.config ?? {}, actions: c.actions ?? [], enabled: !c.enabled } });
  // v12.4.13 (#483): the OAuth fields are deliberately NOT sent here. The API keeps what it holds for any field a
  // caller omits, so flipping Enabled can no longer blank a connection's credentials - which is what 12.4.12 did,
  // and doubly so while the read-back was broken and the card had nothing to carry through.

  return (
    <div className="organization-panel integrations-panel">
      {/* ── 1. Webhooks ───────────────────────────────────────────────────── */}
      <section className={`settings-section-card${webhooksDirty ? ' dirty' : ''}`}>
        <header className="settings-section-header">
          <div className="settings-section-headrow">
            <h2>Webhooks<HelpTooltip sections={[['What it does', 'Outbound webhooks that POST call events to your own systems as they happen — one endpoint per destination, each subscribing to its own events.'], ['When it fires', <>Once integrations are active, a matching event on a call POSTs to every enabled endpoint subscribed to it. Delivery is background-only and <em>never</em> blocks the live caller.</>], ['Example', <>A clinical endpoint at your EHR takes <em>call.ended</em> and <em>identity.captured</em>; a separate billing endpoint takes only <em>call.ended</em>.</>]]} /></h2>
            <div className="settings-actions">
              <span className="ho-enable">
                <span className="ho-en-lbl">Enabled<HelpTooltip sections={[['What it does', 'The master switch for all webhook delivery. When off, no endpoint receives events regardless of its own enable state.'], ['When it fires', 'Takes effect on save — this toggle is save-gated for this section. Once integrations are active, delivery only occurs while this is on.'], ['Example', <>Turn this <em>off</em> during a systems migration to pause every endpoint at once, then back <em>on</em> to resume without touching individual endpoints.</>]]} /></span>
                {/* v12.10.11.1 (#1487): delivery can only be switched on once an endpoint exists */}
                <button type="button" className={`day-toggle${draftEnabled ? '' : ' off'}`} onClick={() => setDraftEnabled((v) => !v)} disabled={!draftEnabled && data.webhooks.length === 0} title={!draftEnabled && data.webhooks.length === 0 ? 'Add an endpoint first' : undefined} aria-label="Toggle webhooks"><span className="knob" /></button>
              </span>
              <button type="button" className="btn-soft" onClick={() => setHookDrawer({ index: null })}><PlusIcon /> Add endpoint</button>
              <button type="button" className="settings-secondary" disabled={!webhooksDirty || saveSettings.isPending} onClick={() => setDraftEnabled(savedEnabled)}>Discard</button>
              <button type="button" className="settings-primary" disabled={!webhooksDirty || saveSettings.isPending} onClick={() => saveSettings.mutate({ webhooksEnabled: draftEnabled, fp: draftFp })}>{saveSettings.isPending ? 'Saving…' : 'Save section'}</button>
            </div>
          </div>
          <p className="int-sec-desc">Outbound webhooks that POST call events to your systems as they happen. Add one endpoint per destination — each subscribes to its own events (e.g. clinical events to your EHR, billing events to your billing system). The master switch turns all delivery on or off.</p>
        </header>
        <div className="int-section-body">
          <div className={`int-body${draftEnabled ? '' : ' ho-disabled'}`}>
            {data.webhooks.length === 0 ? (
              <div className="conn-empty">No endpoints yet. Add one to POST call events to your systems.</div>
            ) : (
              <div className="conn-grid">
                {data.webhooks.map((h, i) => {
                  const configured = !!h.url && /^https?:\/\/.+\..+/.test(h.url);
                  const enabled = h.enabled;
                  const pillClass = !enabled ? 'kb-status' : (configured ? 'conn-on' : 'kb-status');
                  const pillText = !enabled ? 'Disabled' : (configured ? 'Active' : 'Not configured');
                  return (
                    <div key={h.id} className={`conn-card ${configured ? '' : 'pending'} ${enabled ? '' : 'conn-disabled'}`}>
                      <div className="conn-card-head">
                        <div className="conn-ic">{configured ? <CheckCircleIcon /> : <AlertCircleIcon />}</div>
                        <div className="conn-meta">
                          <div className="conn-name-row"><span className="conn-name">{h.name || 'Untitled endpoint'}</span></div>
                          <div className="conn-sub">{h.url ? h.url.replace(/^https?:\/\//, '') : 'No URL yet'}</div>
                        </div>
                        <div className="conn-acts">
                          <span className="ho-enable"><button type="button" className={`day-toggle${h.enabled ? '' : ' off'}`} onClick={() => toggleHookEnabled(h)} aria-label="Enable endpoint" disabled={updateHook.isPending}><span className="knob" /></button></span>
                          <span className={`rec-pill ${pillClass}`}><span className="dot" /> {pillText}</span>
                          <button type="button" className="icon-btn" onClick={() => setHookDrawer({ index: i })} aria-label="Edit endpoint"><EditIcon /></button>
                          <button type="button" className="icon-btn danger" onClick={() => deleteHook.mutate(h.id)} aria-label="Delete endpoint"><TrashIcon /></button>
                        </div>
                      </div>
                      <div className="conn-card-foot">
                        <span className="conn-foot-i"><FlagIcon /> {h.events.length} of {eventCatalog.length} events</span>
                        <span className="conn-foot-i"><LockIcon /> {h.authHeader || 'No auth'}</span>
                        <button type="button" className="conn-foot-i test-btn" onClick={() => testHook.mutate(h.id)} disabled={!configured || testHook.isPending} title={configured ? 'POST a sample payload to this endpoint' : 'Add a URL first'}><SendIcon /> Send test event</button>
                      </div>
                    </div>
                  );
                })}
              </div>
            )}
          </div>
        </div>
      </section>

      {/* ── 2. Connected systems ──────────────────────────────────────────── */}
      <section className="settings-section-card">
        <header className="settings-section-header">
          <div className="settings-section-headrow">
            <h2>Connected systems<HelpTooltip sections={[['What it does', 'External systems the AI can call during a conversation — check availability, book, look up a patient, fetch a chart number. You define each system, its auth, and the actions the AI may invoke.'], ['When it fires', <>Configuration is stored now and applies as soon as you save the drawer; the AI will call these systems mid-conversation <em>once integrations are active</em>. A connection reads as Connected when its required fields are present — there is no live probe.</>], ['Example', <>A REST connection to your practice EHR with a <em>Check availability</em> action the AI runs before offering an appointment.</>]]} /></h2>
            <div className="settings-actions">
              <button type="button" className="btn-soft" onClick={() => setConnDrawer({ index: null })}><PlusIcon /> Add integration</button>
            </div>
          </div>
          <p className="int-sec-desc">External systems the AI can call <em>during</em> a conversation — check availability, book, look up a patient, fetch a chart number. Fully custom: define each action’s endpoint and inputs. Changes apply as soon as you save the drawer.</p>
        </header>
        <div className="int-section-body">
          {data.connectedSystems.length === 0 ? (
            <div className="conn-empty">No connections yet. Add one to let the AI call your systems during a call.</div>
          ) : (
            <div className="conn-grid">
              {data.connectedSystems.map((c, i) => {
                const configured = c.status === 'configured';
                const enabled = c.enabled;
                const pillClass = !enabled ? 'kb-status' : (configured ? 'conn-on' : 'kb-status');
                const pillText = !enabled ? 'Disabled' : (configured ? 'Connected' : 'Not configured');
                const showActions = connUsesActions(c.type);
                return (
                  <div key={c.id} className={`conn-card ${configured ? '' : 'pending'} ${enabled ? '' : 'conn-disabled'}`}>
                    <div className="conn-card-head">
                      <div className="conn-ic">{configured ? <CheckCircleIcon /> : <AlertCircleIcon />}</div>
                      <div className="conn-meta">
                        <div className="conn-name-row"><span className="conn-name">{c.name || 'Untitled connection'}</span><span className="conn-type-tag">{connTypeLabel(c.type)}</span></div>
                        <div className="conn-sub">{connSummaryLine(c)}</div>
                      </div>
                      <div className="conn-acts">
                        <span className="ho-enable"><button type="button" className={`day-toggle${c.enabled ? '' : ' off'}`} onClick={() => toggleConnEnabled(c)} aria-label="Enable connection" disabled={updateConn.isPending}><span className="knob" /></button></span>
                        <span className={`rec-pill ${pillClass}`}><span className="dot" /> {pillText}</span>
                        <button type="button" className="icon-btn" onClick={() => setConnDrawer({ index: i })} aria-label="Edit connection"><EditIcon /></button>
                        <button type="button" className="icon-btn danger" onClick={() => deleteConn.mutate(c.id)} aria-label="Delete connection"><TrashIcon /></button>
                      </div>
                    </div>
                    <div className="conn-card-foot">
                      {showActions && <span className="conn-foot-i"><BoltIcon /> {c.actions.length} {c.actions.length === 1 ? 'action' : 'actions'}</span>}
                      <span className="conn-foot-i"><LockIcon /> {connAuthLabel(c.authMethod)}</span>
                      {/* v12.10.28 (#2209): Translations - what this system calls each location / provider / visit type. */}
                      <button type="button" className="conn-tr-btn" onClick={() => setTrFor({ id: String(c.id), name: c.name })}>Translations</button>
                      {/* v12.4.13 (#486): Check Connection - the quick primary check, in the T4 Provider Registry style.
                          The per-action and token tests live inside the editor, beside the fields they exercise. */}
                      {showActions && (
                        <button type="button" className="conn-test-btn" onClick={() => runCheck(c)} disabled={checks[c.id] === 'pending'}>
                          <PlugIcon /> {checks[c.id] === 'pending' ? 'Checking…' : 'Check connection'}
                        </button>
                      )}
                    </div>
                    {checks[c.id] && checks[c.id] !== 'pending' && (() => { const r = checks[c.id] as TestResult; return (
                      <div className={`conn-check-line ${r.ok ? 'ok' : 'err'}`}>
                        {r.ok ? <CheckCircleIcon /> : <AlertCircleIcon />}
                        <span>{r.detail}</span>
                        {r.status ? <span className="ct-status">HTTP {r.status}</span> : null}
                      </div>
                    ); })()}
                  </div>
                );
              })}
            </div>
          )}
        </div>
      </section>

      {/* ── 3. Failure policy ─────────────────────────────────────────────── */}
      <section className={`settings-section-card${failureDirty ? ' dirty' : ''}`}>
        <header className="settings-section-header">
          <div className="settings-section-headrow">
            <h2>Failure policy</h2>
            <div className="settings-actions">
              <button type="button" className="settings-secondary" disabled={!failureDirty || saveSettings.isPending} onClick={() => setDraftFp(savedFp ? structuredClone(savedFp) : draftFp)}>Discard</button>
              <button type="button" className="settings-primary" disabled={!failureDirty || saveSettings.isPending} onClick={() => saveSettings.mutate({ webhooksEnabled: draftEnabled, fp: draftFp })}>{saveSettings.isPending ? 'Saving…' : 'Save section'}</button>
            </div>
          </div>
          <p className="int-sec-desc">The universal policy for integration failures — both background webhook delivery and connected-system calls the AI makes during a live call.</p>
        </header>
        <div className="int-section-body">
          {/* Block 1 — webhook delivery failure (background) */}
          <div className="subhead">Webhook delivery failure</div>
          <p className="sub-note" style={{ marginTop: -4 }}>Background delivery of call events to your endpoints — never affects a live caller.</p>
          <div className="warn-note" style={{ marginTop: 10 }}>
            <AlertTriIcon />
            <div>Webhook delivery is independent of the live call — a caller is <em>never</em> blocked or delayed by a webhook failure. This policy only governs retry and alerting behind the scenes.</div>
          </div>
          <div className="fr" style={{ marginTop: 18 }}>
            <Field label="Retry policy" help={[['What it does', 'How many times, and on what schedule, we retry a failed webhook delivery.'], ['When it fires', 'Each time your endpoint returns 5xx, times out, or is unreachable.'], ['Example', <><em>3 retries · exponential backoff</em> spaces attempts at 30s, 2m, 10m before giving up.</>]]}>
              <select value={normalizeRetryPolicy(draftFp.webhookRetryPolicy)} onChange={(e) => patchFp({ webhookRetryPolicy: e.target.value })}>
                {WEBHOOK_RETRY.map(([v, l]) => <option key={v} value={v}>{l}</option>)}
              </select>
            </Field>
            <Field label="On final failure" help={[['What it does', 'What happens to the event after all retries are exhausted.'], ['When it fires', 'Once the retry schedule is fully spent without a successful delivery.'], ['Example', <><em>Queue for manual replay</em> holds it so you can re-send later. <em>Drop and alert admin</em> notifies the alert recipient. <em>Drop silently</em> discards it.</>]]}>
              <select value={draftFp.webhookOnFinalFailure} onChange={(e) => patchFp({ webhookOnFinalFailure: e.target.value })}>
                {WEBHOOK_FINAL.map(([v, l]) => <option key={v} value={v}>{l}</option>)}
              </select>
            </Field>
          </div>
          <div className="fr">
            <Field full label="Alert recipient" help={[['What it does', 'The email notified when a webhook permanently fails (if On final failure is set to alert).'], ['When it fires', 'On final delivery failure, when alerting is enabled.'], ['Example', 'ops@yourpractice.com → your ops team is emailed so the missed event can be replayed.']]}>
              <div className="with-ic">
                <MailIcon />
                <input type="email" value={draftFp.webhookAlertEmail} onChange={(e) => patchFp({ webhookAlertEmail: e.target.value })} placeholder="ops@yourpractice.com" />
              </div>
            </Field>
          </div>

          {/* Block 2 — connected-system failure (mid-call) */}
          <div className="subhead" style={{ marginTop: 26 }}>Connected-system failure <span className="hint">— during a live call</span></div>
          <p className="sub-note" style={{ marginTop: -4 }}>When the AI calls a connected system mid-conversation (e.g. checking the EHR for appointment slots) and it errors, times out, or is unreachable.</p>
          {/* v12.7.1 (#590 / BDR-014): this note used to send the tenant to Reliability for the timeout. After
              12.7.0 that sentence was false - the engine had stopped reading Reliability for connected-system
              calls - and a screen that describes a number it no longer controls is worse than a missing field,
              because the tenant acts on it. Everything governing such a call is set here now. */}
          <div className="xref-note" style={{ marginTop: 10 }}>
            <PlugIcon />
            <div>Everything that governs an outbound call to a connected system is set here — how long we wait, how many times we try, and what the caller hears when it fails. <em>Reliability</em> governs our own AI providers and no longer affects these calls.</div>
          </div>
          <div className="fr" style={{ marginTop: 18 }}>
            {/* v12.7.1 (#590 / BDR-014): 12.7.0 moved where the ENGINE reads this from. It did not move where a
                tenant SETS it, so every tenant was frozen at whatever the migration backfilled. This is that
                field. Bounds match the Reliability control's own (500-30,000 ms) so the number means the same
                thing on whichever screen you last saw it. Empty clears the override. */}
            <Field label="Action timeout" help={[['What it does', 'How long we wait for a single outbound call to a connected system before counting that attempt as failed.'], ['When it fires', 'On every call to a connected system \u2014 a booking, a slot lookup, a patient match.'], ['Example', <><em>6,000 ms</em> → wait six seconds for their endpoint, then retry or fall back per the fields beside this one.</>], ['Note', <>This governs THEIR endpoint. Our own AI providers keep a separate timeout under <em>Reliability</em>, and changing one no longer changes the other.</>]]}>
              <MsField value={draftFp.csActionTimeoutMs} onChange={(v) => patchFp({ csActionTimeoutMs: v })} min={500} max={30000} step={500} />
            </Field>
            <Field label="Retry attempts" help={[['What it does', 'How many times the AI silently retries the connected-system call before giving up and applying the caller fallback below.'], ['When it fires', 'When a connected-system call returns an error or exceeds its action timeout.'], ['Example', <><em>1 retry</em> → try once more quietly; if it still fails, apply the caller fallback.</>]]}>
              <select value={String(draftFp.csRetryAttempts)} onChange={(e) => patchFp({ csRetryAttempts: Number(e.target.value) })}>
                {CS_RETRY.map(([v, l]) => <option key={v} value={v}>{l}</option>)}
              </select>
            </Field>
            <Field label="Caller fallback" help={[['What it does', 'What the assistant does with the caller when a connected system can’t be reached during the call.'], ['When it fires', 'After retries are exhausted on a mid-call connected-system failure.'], ['Example', <><em>Take a message</em> = capture details and log a follow-up. <em>Hand off to staff</em> = transfer per your Handoff settings. <em>Continue without the lookup</em> = proceed conversationally. <em>Route to voicemail</em> = offer voicemail.</>]]}>
              <select value={draftFp.csCallerFallback} onChange={(e) => patchFp({ csCallerFallback: e.target.value })}>
                {CS_FALLBACK.map(([v, l]) => <option key={v} value={v}>{l}</option>)}
              </select>
            </Field>
          </div>
          {/* v12.4.16 (#515): THE COMBINED EFFECT, WHERE THE RETRIES ARE SET. The same sentence and the same
              arithmetic as the Reliability screen - one helper, so the two can never disagree. */}
          {(() => {
            const b = holdBudget(draftFp.csActionTimeoutMs ?? HOLD_DEFAULT_ACTION_TIMEOUT_MS, draftFp.csRetryAttempts);
            return (
              <div className={b.clamped ? 'warn-note' : 'xref-note'} style={{ marginTop: 14 }}>
                <ClockIcon />
                <div>
                  <b>Worst case a caller is held: {holdSeconds(b.budgetMs)}</b>{' \u2014 '}{holdWorking(b)}.
                  {' '}{(b.clamped || b.raised) && <>{holdOutcome(b)}{' '}</>}
                  Both numbers are the two fields above &mdash; a {b.timeoutMs.toLocaleString('en-US')} ms timeout and
                  the retry count. The action runs in the background and the caller is held with a
                  filler rather than dropped, so this decides how long they wait &mdash; not whether the call survives.
                </div>
              </div>
            );
          })()}
          <div className="fr">
            <Field full label="What the assistant says" help={[['What it does', 'The spoken line the AI uses when a connected system is unavailable, before applying the fallback.'], ['When it fires', 'On a mid-call connected-system failure, spoken to the caller.'], ['Example', '“I’m having trouble reaching our scheduling system right now — let me take a message and have someone follow up.”']]}>
              <input value={draftFp.csSpokenLine} onChange={(e) => patchFp({ csSpokenLine: e.target.value })} placeholder="I'm having trouble reaching our system right now — let me take a message and have someone follow up." />
            </Field>
          </div>
        </div>
      </section>

      {hookDrawer && (
        <WebhookDrawer
          webhook={hookDrawer.index == null ? null : data.webhooks[hookDrawer.index]}
          eventCatalog={eventCatalog}
          saving={createHook.isPending || updateHook.isPending}
          onClose={() => setHookDrawer(null)}
          onSave={async (body, id) => { if (id) await updateHook.mutateAsync({ id, body }); else await createHook.mutateAsync(body); setHookDrawer(null); }}
        />
      )}
      {connDrawer && (
        <ConnectedSystemDrawer
          system={connDrawer.index == null ? null : data.connectedSystems[connDrawer.index]}
          saving={createConn.isPending || updateConn.isPending}
          onClose={() => setConnDrawer(null)}
          onSave={async (body, id) => { if (id) await updateConn.mutateAsync({ id, body }); else await createConn.mutateAsync(body); setConnDrawer(null); }}
        />
      )}
      {trFor && <TranslationsDrawer systemId={trFor.id} systemName={trFor.name} onClose={() => setTrFor(null)} onSaved={(m) => showToast(m)} />}
      {toast && <div className="settings-toast-wrap" role="status" aria-live="polite"><div className="settings-toast">{toast}</div></div>}
    </div>
  );
}

function connSummaryLine(c: IntConnectedSystem): string {
  if (c.type === 'rest' || c.type === 'fhir') return c.baseUrl || 'No base URL set';
  const cfg = c.config ?? {};
  if (c.type === 'hl7') return (cfg.hl7Endpoint as string) || 'No MLLP endpoint set';
  if (c.type === 'sftp') { const host = cfg.sftpHost as string; return host ? `${host}:${cfg.sftpPort ?? 22}${cfg.sftpPath ?? ''}` : 'No host set'; }
  return '';
}

/* ── Webhook drawer ─────────────────────────────────────────────────────── */
interface HookBody { name: string; url: string; authHeader: string; authValue: string; events: string[]; enabled: boolean }

function WebhookDrawer({ webhook, eventCatalog, saving, onClose, onSave }: {
  webhook: IntWebhook | null; eventCatalog: string[]; saving: boolean;
  onClose: () => void; onSave: (body: HookBody, id: string | null) => void;
}) {
  const editing = webhook != null;
  const [name, setName] = useState(webhook?.name ?? '');
  const [url, setUrl] = useState(webhook?.url ?? '');
  const [authHeader, setAuthHeader] = useState(webhook?.authHeader ?? 'Authorization');
  // §C1: never seed the stored secret. Empty + placeholder when one is already saved.
  const [authValue, setAuthValue] = useState('');
  const [showSecret, setShowSecret] = useState(false);
  // Per-card toggle owns the enabled flag (applies immediately); the drawer preserves it.
  const enabled = webhook?.enabled ?? true;
  const [events, setEvents] = useState<Set<string>>(new Set(webhook?.events ?? eventCatalog));

  const nameValid = name.trim().length > 0;
  const urlValid = url.trim() === '' || /^https?:\/\/.+\..+/.test(url.trim());
  const canSave = nameValid && urlValid;
  const hasStoredSecret = webhook?.hasAuth ?? false;

  const toggleEvent = (ev: string) => setEvents((s) => { const next = new Set(s); if (next.has(ev)) next.delete(ev); else next.add(ev); return next; });

  const submit = () => {
    if (!canSave) return;
    // Send the typed secret; if the user left it blank but one is stored, send the keep-sentinel.
    const authValueOut = authValue.trim() !== '' ? authValue : (hasStoredSecret ? SECRET_KEEP : '');
    onSave({ name: name.trim(), url: url.trim(), authHeader: authHeader.trim(), authValue: authValueOut, events: eventCatalog.filter((ev) => events.has(ev)), enabled }, webhook?.id ?? null);
  };

  return (
    <Drawer onClose={onClose} title={editing ? 'Edit endpoint' : 'Add endpoint'} subtitle="POST selected call events to one destination."
      footer={<><button type="button" className="mc" onClick={onClose}>Cancel</button><button type="button" className="ma" disabled={!canSave || saving} onClick={submit}><SaveIcon /> {saving ? 'Saving…' : 'Save endpoint'}</button></>}>
      <div className="f"><label>Endpoint name<HelpTooltip sections={[['What it does', 'A label for this destination, shown on the endpoint card and used to tell your endpoints apart. It is not sent in the request.'], ['When it fires', 'Used only in this admin UI — it appears on the card and in test-event toasts.'], ['Example', <>Name it <em>Billing system</em> or <em>Practice EHR</em> so the card is self-explanatory at a glance.</>]]} /></label><input value={name} onChange={(e) => setName(e.target.value)} placeholder="e.g. Billing system" /></div>
      <div className={`f${url && !urlValid ? ' invalid' : ''}`}>
        <label>Webhook URL <span className="hint">— leave blank to keep as “not configured”</span><HelpTooltip sections={[['What it does', 'The HTTPS destination that subscribed events are POSTed to. Must look like https://host.domain/path. Leave it blank to keep the endpoint parked as “not configured”.'], ['When it fires', <>Once integrations are active, each subscribed event POSTs here. It also drives the card status: a valid URL reads <em>Active</em> (when enabled), otherwise <em>Not configured</em>. Send test event POSTs a sample envelope here immediately.</>], ['Example', <><em>https://hooks.example.com/inbound</em> — your receiver at that path gets the event payload.</>]]} /></label>
        <div className="with-ic"><PlugIcon /><input value={url} onChange={(e) => setUrl(e.target.value)} placeholder="https://hooks.example.com/inbound" /></div>
        <span className="errmsg">Enter a valid URL (https://host.domain/…).</span>
      </div>
      <div className="fr">
        <div className="f"><label>Auth header name<HelpTooltip sections={[['What it does', 'The name of the HTTP header sent with each delivery, carrying the auth value below. Defaults to Authorization.'], ['When it fires', 'Once integrations are active, this header is attached to every POST to this endpoint (and to the test event).'], ['Example', <><em>Authorization</em> for a bearer token, or a custom header like <em>X-Api-Key</em> if your receiver expects one.</>]]} /></label><input value={authHeader} onChange={(e) => setAuthHeader(e.target.value)} placeholder="Authorization" /></div>
        <div className="f">
          <label>Auth header value<HelpTooltip sections={[['What it does', 'The secret sent in the auth header. It is AES-encrypted at rest and never returned to this screen — the field shows only whether a value is saved.'], ['When it fires', 'Sent as the auth header value on every delivery once integrations are active. Leave it blank when editing to keep the stored value unchanged; type a new value to replace it.'], ['Example', <>Paste <em>Bearer eyJhbGciOi…</em> for a token. On a later edit the field stays empty and reads “Saved — leave blank to keep”.</>]]} /></label>
          <div className="secret-row">
            <input type={showSecret ? 'text' : 'password'} className="secret-input" value={authValue} onChange={(e) => setAuthValue(e.target.value)} placeholder={hasStoredSecret ? 'Saved — leave blank to keep' : 'Enter a token or key'} autoComplete="new-password" />
            <button type="button" className="secret-toggle" onClick={() => setShowSecret((v) => !v)} aria-label={showSecret ? 'Hide value' : 'Show value'}>{showSecret ? <EyeOffIcon /> : <EyeIcon />}</button>
          </div>
        </div>
      </div>
      <div className="conn-secret-note"><LockIcon /><span>The auth value is stored securely and never shown again. Leave it blank to keep the saved value.</span></div>
      <div className="subhead" style={{ marginTop: 18 }}>Event subscriptions <span className="hint">— only checked events POST to this endpoint</span><HelpTooltip sections={[['What it does', 'Selects which call events this endpoint receives. Only checked events POST here; the card shows the count as “N of M events”.'], ['When it fires', 'Once integrations are active, an event POSTs to this endpoint only if it is checked here. New endpoints default to all events selected.'], ['Example', <>Check <em>call.ended</em> and <em>identity.captured</em> for a clinical endpoint; uncheck the rest so it only hears what it needs.</>]]} /></div>
      <div className="evt-grid">
        {eventCatalog.map((ev) => (
          <button key={ev} type="button" className={`evt-chip${events.has(ev) ? ' on' : ''}`} onClick={() => toggleEvent(ev)}>
            <span className="evt-check"><CheckIcon /></span>
            <span className="evt-meta"><span className="evt-name">{ev}</span><span className="evt-desc">{EVENT_DESC[ev] ?? ''}</span></span>
          </button>
        ))}
      </div>
    </Drawer>
  );
}

/* ── Connected-system drawer ────────────────────────────────────────────── */
interface ConnBody { name: string; type: string; authMethod: string; secret: string; baseUrl: string; fhirVersion: string; config: Record<string, unknown>; actions: IntAction[]; enabled: boolean;
  // v12.4.13 (#483): OPTIONAL on the wire. The API keeps a field the caller omits, so a partial save (the card's
  // Enabled toggle) can no longer blank a connection's OAuth settings.
  oauthTokenUrl?: string; oauthGrantType?: string; oauthClientId?: string; oauthScope?: string }

// v12.4.12 (#482): common action Content-Types offered as suggestions; any valid media type can be typed.
const CONTENT_TYPES = ['application/json', 'application/x-www-form-urlencoded', 'application/fhir+json', 'application/xml', 'text/plain'];
const OAUTH_DEFAULT_GRANT = 'client_credentials';
// v12.4.12 (#482): in a path or JSON body only a brace pair with no quote, colon, comma or line break is a token -
// the same rule the API's TokenResolver.RenderForRequest applies - so `{"a": 1}` is never drawn as a chip.
const isRequestToken = (inner: string) => !/["':,\r\n]/.test(inner) && inner.trim().length > 0;

// v12.4.16 (#498): THE `response.` DISPLAY PREFIX IS GONE. COLUMN HEADERS DO ITS JOB WITHOUT LYING.
//
// #492 (12.4.15) added it for a real problem - Tushar: "this is kind of confusing to understand where the result
// field applies to ours - if you see data.appointmentId looks like the value we are setting to other." A row gave
// no clue which side was whose. But the prefix solved it by making one word mean two things across a single row:
// `response.` is THEIR document on the left, while our side of the very same row is now the `external.*` family
// (BDR-001 v1.2 section 7.1) - and `response` was in the running for that name and was rejected for exactly this.
//
// The header says whose side it is, once, above the column, which is where that information belongs:
//     Their field            ->   Our token
//     data.id                ->   External system > Reference
// Their path stays hierarchical because it is a PATH - `data.id` is where the value physically is. Ours is flat,
// because a caller-facing read-back should never require a JSON path.
//
// storePath survives as a one-way cleaner: the prefix was display-only, so nothing stored should carry it, but a
// tenant who typed it into the datalist on 12.4.15 would have stored a path the engine could never read.
const RESP_PREFIX = 'response.';
const storePath = (p: string) => {
  const t = (p ?? '').trim();
  return t.toLowerCase().startsWith(RESP_PREFIX) ? t.slice(RESP_PREFIX.length) : t;
};

// v12.4.15 (#492): what was tested, as one string. Any edit to the request or the rule changes it, which is how the
// pill knows its stored OK no longer describes what is on screen.
const testFingerprint = (a: IntAction) => [
  (a.method || '').toUpperCase(), (a.path ?? '').trim(), (a.contentType ?? '').trim(), a.body ?? '',
  JSON.stringify(a.formats ?? {}),   // v12.5.2 (#496): a format change is a real change - without this the Save button never lit up
  a.response?.resultField ?? '', a.response?.successValues ?? '', a.response?.failureValues ?? '',
].join('\u0001');

// v12.4.15 (#492): HIS DEFINITION OF READY, and it is deliberately strict - "path + body + result rule". An action
// with no result rule is judged by HTTP status alone, which is exactly how a 200 carrying {"status": false} becomes a
// spoken confirmation. The readout is the only place that says so before a live call does.
const methodCarriesBody = (m: string) => { const u = (m || '').toUpperCase(); return u === 'POST' || u === 'PUT' || u === 'PATCH'; };
function actionReady(a: IntAction): boolean {
  if (!(a.name ?? '').trim() || !(a.path ?? '').trim()) return false;
  if (methodCarriesBody(a.method) && !(a.body ?? '').trim()) return false;
  const r = a.response;
  return !!(r?.resultField ?? '').trim() && !!(r?.successValues ?? '').trim();
}

// v12.4.15 (#492): "last tested" in words. Deliberately coarse - the point is whether the result is from this
// afternoon or from August, not the minute it happened.
function whenWords(iso: string): string {
  const t = Date.parse(iso);
  if (!Number.isFinite(t)) return 'earlier';
  const mins = Math.max(0, Math.round((Date.now() - t) / 60000));
  if (mins < 2) return 'just now';
  if (mins < 60) return `${mins} minutes ago`;
  const hrs = Math.round(mins / 60);
  if (hrs < 24) return `${hrs} hour${hrs === 1 ? '' : 's'} ago`;
  const days = Math.round(hrs / 24);
  return days === 1 ? 'yesterday' : `${days} days ago`;
}

// v12.4.15 (#492): what the dot on a pill means. The order matters: a STORED PASS AGAINST AN EDITED REQUEST is not a
// pass, and saying so is the whole reason the fingerprint exists - a green tick beside a path that has changed since
// is the same confident wrong answer as #489's capital S.
function actionBadge(a: IntAction): { kind: 'ok' | 'fail' | 'stale' | 'ready' | 'todo'; title: string } {
  const t = a.lastTest;
  if (t && t.fp && t.fp !== testFingerprint(a)) return { kind: 'stale', title: `Tested ${whenWords(t.at)}, edited since` };
  if (t) return t.ok
    ? { kind: 'ok', title: `Tested ${whenWords(t.at)} \u00b7 worked` }
    : { kind: 'fail', title: `Tested ${whenWords(t.at)} \u00b7 failed${t.status ? ` (HTTP ${t.status})` : ''}` };
  return actionReady(a)
    ? { kind: 'ready', title: 'Ready \u2014 never tested' }
    : { kind: 'todo', title: 'Not ready \u2014 needs a path, a body, or a result rule' };
}

// v12.4.14 (#85a): the field names of a pasted sample, as dotted paths - the mirror of the engine's
// ActionResponse.Paths (dots for objects, [0] for the first array item, same depth cap), so what the editor
// offers to pick is exactly what the engine can read back on a live call.
// ── v12.7.2 (#592): THE SUCCESS RULE IS A MAPPING, LIKE EVERY OTHER VALUE ON THIS DRAWER. ──────────
//
// The result FIELD has been a dropdown since #489 - picked from their sample answer. The success VALUE next
// to it was free text, so one drawer carried two mental models and the free-text half silently accepted a
// typo: "ture" saves, looks configured, and every booking reads as a failure for ever. #489 is the same
// defect one field to the left, where his `Status` against PMWeb's `status` resolved to nothing.
//
// Tushar, 2026-09-22, over-ruling my offer to drop this from the release: *"no this is really need to close
// the integration requirement for good. for us there is success and failure - so mapping our field of success
// to true from response is the correct way to go."*
//
// The observed value at that path comes first, because it is the one that is definitely real. The literals
// follow for a tenant configuring an action before they have a sample. A STORED value that matches neither is
// kept and labelled, never silently dropped - the #487 rule this codebase applies everywhere a picker
// replaced a text box.
const SUCCESS_LITERALS = ['true', 'false', '1', '0', 'success', 'ok', 'error'];

function sampleValueAt(json: string, path: string): string | null {
  if (!path.trim()) return null;
  let node: unknown;
  try { node = JSON.parse(json); } catch { return null; }
  for (const seg of path.split('.')) {
    if (node === null || typeof node !== 'object') return null;
    node = (node as Record<string, unknown>)[seg];
  }
  if (node === null || typeof node === 'object') return null;
  return String(node);
}

function successOptions(sample: string, resultField: string, current: string): string[] {
  const seen = sampleValueAt(sample, resultField);
  const out: string[] = [];
  const push = (v: string) => { if (v && !out.some(x => x.toLowerCase() === v.toLowerCase())) out.push(v); };
  if (seen !== null) push(seen);
  SUCCESS_LITERALS.forEach(push);
  push(current.trim());
  return out;
}

function samplePaths(json: string, maxDepth = 4): string[] {
  let root: unknown;
  try { root = JSON.parse(json); } catch { return []; }
  const found: string[] = [];
  const isLeaf = (v: unknown) => v === null || typeof v !== 'object';
  const walk = (node: unknown, prefix: string, depth: number) => {
    if (node === null || typeof node !== 'object' || depth > maxDepth || found.length > 200) return;
    if (Array.isArray(node)) {
      if (node.length === 0) return;
      const first = `${prefix}[0]`;
      if (isLeaf(node[0])) found.push(first);
      walk(node[0], first, depth + 1);
      return;
    }
    for (const [key, child] of Object.entries(node as Record<string, unknown>)) {
      const path = prefix.length === 0 ? key : `${prefix}.${key}`;
      if (isLeaf(child)) found.push(path);
      walk(child, path, depth + 1);
    }
  };
  walk(root, '', 0);
  return found;
}

// v12.4.12 (#482): ONE token source for Integrations - the same served catalog + tenant labels every prompt
// editor uses (PromptEditor's hooks), falling back to the canonical default list while the catalog loads.
function useIntegrationTokens() {
  const { catalog, vocab, customFields, lists } = useVocabulary();   // v12.7.3 (#649): lists too
  // v12.4.16 (#499): a tenant-added field is mappable too - it is exactly the kind of field an integration
  // wants on the right of a row (an account number their system returns, say).
  const groups = catalogGroups(catalog, vocab, customFields, lists) ?? TOKEN_GROUPS;   // v12.7.3 (#649)
  // v12.5.2 (#496): the FIELD'S DECLARED TYPE, so the editor can offer a wire format only where one can
  // actually apply. A format box on a name or a ZIP would be noise, and worse, an invitation to set one.
  const typeOf = (t: string): string | undefined => {
    const key = canonToken(t).toLowerCase();
    const dot = key.indexOf('.');
    if (dot < 0) return customFields[key]?.type;
    const ent = key.slice(0, dot), fld = key.slice(dot + 1);
    const entity = (catalog ?? []).find((e) => (e.token ?? '').toLowerCase() === ent);
    const field = entity?.fields?.find((f) => (f.key ?? '').toLowerCase() === fld);
    return field?.type ?? customFields[key]?.type;
  };
  return {
    groups,
    known: groups.flatMap((g) => g.tokens),
    labelOf: (t: string) => tokenLabel(t, vocab, customFields),
    aliasOf: makeAliasOf(vocab),
    typeOf,
  };
}

// v12.5.2 (#496): the formats worth offering, with a worked example beside each so a tenant is choosing a
// SHAPE rather than remembering .NET format syntax. The PM Web ones are first because they are the reason
// this exists. "" means no override - the canonical value goes out as-is, which is what every action did
// before 12.5.2.
const DATE_FORMATS: Array<{ fmt: string; eg: string }> = [
  { fmt: '',                        eg: '2026-09-25  (no override - canonical)' },
  { fmt: 'yyyy-MM-dd',              eg: '2026-09-25' },
  { fmt: 'yyyy-MM-dd HH:mm:ss.fff', eg: '2026-09-25 00:00:00.000' },
  { fmt: 'MM/dd/yyyy',              eg: '09/25/2026' },
  { fmt: 'dd/MM/yyyy',              eg: '25/09/2026' },
  { fmt: 'yyyyMMdd',                eg: '20260925' },
  { fmt: "yyyy-MM-dd'T'HH:mm:ss",   eg: '2026-09-25T00:00:00' },
];
const TIME_FORMATS: Array<{ fmt: string; eg: string }> = [
  { fmt: '',        eg: '15:00  (no override - canonical)' },
  { fmt: 'HH:mm',   eg: '15:00' },
  { fmt: 'hh:mm tt', eg: '03:00 PM' },
  { fmt: 'h:mm tt', eg: '3:00 PM' },
  { fmt: 'HH:mm:ss', eg: '15:00:00' },
];

// Mirrors FieldValues.Wire closely enough to PREVIEW the string that will be sent. It is a preview, not the
// renderer: the server still formats the real value, and this never decides what goes on the wire.
function previewWire(type: string | undefined, canonical: string, fmt: string): string {
  const t = (type ?? '').toLowerCase();
  if (!fmt) return canonical;
  try {
    if (t === 'date') {
      const m = /^(\d{4})-(\d{2})-(\d{2})$/.exec(canonical.trim());
      if (!m) return canonical;
      const [, y, mo, d] = m;
      return fmt
        .replace(/yyyy/g, y).replace(/MM/g, mo).replace(/dd/g, d)
        .replace(/HH/g, '00').replace(/mm/g, '00').replace(/ss/g, '00').replace(/fff/g, '000')
        .replace(/'T'/g, 'T');
    }
    if (t === 'time') {
      const m = /^(\d{2}):(\d{2})$/.exec(canonical.trim());
      if (!m) return canonical;
      const hh = parseInt(m[1], 10), mi = m[2];
      const h12 = ((hh + 11) % 12) + 1, ampm = hh < 12 ? 'AM' : 'PM';
      if (fmt === 'HH:mm') return `${String(hh).padStart(2, '0')}:${mi}`;
      if (fmt === 'HH:mm:ss') return `${String(hh).padStart(2, '0')}:${mi}:00`;
      if (fmt === 'hh:mm tt') return `${String(h12).padStart(2, '0')}:${mi} ${ampm}`;
      if (fmt === 'h:mm tt') return `${h12}:${mi} ${ampm}`;
      return canonical;
    }
  } catch { /* a preview must never throw - fall through to the canonical value */ }
  return canonical;
}

/* ── Response block, per action (v12.4.14 #85a) ─────────────────────── */
// Tushar, 2026-09-19: "we will have to define mapping where the request block is, i believe we need to provide
// another response block where two section, first where the reponse json can be pasted and then the field below it
// we can move our field with whatever important or correct fileds from json can be mapped with ours."
// So: paste one real answer, and everything below is PICKED from it - no path typed by hand, no guessing which
// field means success. Two different providers answering the same question differently is exactly what this
// absorbs: their shape stays theirs, and only the parts we name become our tokens.
function ResponseBlock({ idx, value, onChange, tokens, lastResponse }: {
  idx: number;
  value: IntActionResponse | undefined;
  onChange: (patch: Partial<IntActionResponse>) => void;
  tokens: ReturnType<typeof useIntegrationTokens>;
  lastResponse?: string;
}) {
  const r = value ?? {};
  const sample = r.sample ?? '';
  const trimmed = sample.trim();
  const paths = samplePaths(sample);
  const valid = trimmed.length === 0 ? null : paths.length > 0 || (() => { try { JSON.parse(sample); return true; } catch { return false; } })();
  const rows = r.map ?? [];
  const listId = `int-resp-paths-${idx}`;
  const setRow = (i: number, patch: Partial<IntActionResponseMap>) =>
    onChange({ map: rows.map((x, j) => (j === i ? { ...x, ...patch } : x)) });

  // v12.4.15 (#492): THE SAMPLE IS STEP ONE. Tushar, 2026-09-19: "field should be disabled with no data as it is not
  // gonna allow to go anywhere without it." So with nothing pasted the rule and the mappings are disabled.
  // THE EXCEPTION THAT KEEPS THIS FROM BECOMING #483: an action saved BEFORE this existed may hold a result field and
  // mappings with no sample. Those are shown READ-ONLY rather than blank - a field that opens empty and is written
  // back on the next Save is exactly how #483 destroyed the stored OAuth credentials. The engine keeps using the
  // stored rule on live calls whatever this screen shows.
  const hasStored = !!(r.resultField ?? '').trim() || rows.length > 0;
  const locked = !valid;                 // no usable sample yet
  const readOnlyStored = locked && hasStored;

  const pathOptions = (current: string) => {
    const opts = paths.slice();
    const cur = storePath(current);
    if (cur && !opts.includes(cur)) opts.unshift(cur);   // never hide a value the tenant already has
    return opts;
  };

  return (
    <div className="ca-resp">
      <div className="ca-resp-head">Response <span className="hint">&mdash; what their answer means, and which parts we keep</span>
        <HelpTooltip sections={[
          ['What it does', <>Teaches the platform to read this action&rsquo;s answer. Paste one real response and the fields below fill in from it: which field says whether it worked, what its values mean, and which parts of the answer become captured values the AI can speak back.</>],
          ['When it fires', <>On every live call that runs this action. A response that is not a success never becomes a confirmation &mdash; the caller is taken down the failure route instead.</>],
          ['Example', <>Paste <em>{'{"status": true, "data": {"id": "A-4471"}}'}</em>, set the result field to <em>status</em>, success <em>true</em>, and map their <em>data.id</em> to our <em>External system &rsaquo; Reference</em>.</>]]} />
      </div>

      <label className="ca-body-label" htmlFor={`ca-resp-sample-${idx}`}>Sample response <span className="hint">&mdash; paste one real answer from this system; everything below fills in from it</span></label>
      <textarea id={`ca-resp-sample-${idx}`} className="ca-resp-sample" rows={6} spellCheck={false} value={sample}
        onChange={(e) => onChange({ sample: e.target.value })}
        placeholder={'{\n  "status": true,\n  "message": "Appointment created",\n  "data": { "id": "A-4471" }\n}'} />
      <div className="ca-resp-tools">
        {lastResponse ? <button type="button" className="btn-soft" onClick={() => onChange({ sample: lastResponse })}>Use the last test response</button> : null}
        {trimmed.length > 0 ? <button type="button" className="btn-soft" onClick={() => { try { onChange({ sample: JSON.stringify(JSON.parse(sample), null, 2) }); } catch { /* left as typed */ } }}>Tidy</button> : null}
        {valid === false ? <span className="ca-resp-warn">&#9888; Not valid JSON yet.</span>
          : valid === true ? <span className="ca-resp-ok">{paths.length} field{paths.length === 1 ? '' : 's'} found.</span> : null}
      </div>
      <datalist id={listId}>{paths.map((x) => <option key={x} value={x} />)}</datalist>

      {locked && !hasStored && (
        <p className="ca-resp-note ca-resp-locked">Paste an answer above and these fill in from it. Until then there is nothing to pick from.</p>
      )}
      {readOnlyStored && (
        <p className="ca-resp-note ca-resp-locked">&#9888; Saved before a sample was kept. The values below are still in use on live calls and are shown as stored &mdash; paste a sample to change them.</p>
      )}

      <div className="ca-resp-grid">
        <div className="f">
          <label>Result field <span className="hint">&mdash; their field that says whether it worked</span>
            <HelpTooltip sections={[
              ['What it does', <>Names the field in <b>their</b> answer that decides success &mdash; for example <em>status</em>. Left blank, only the HTTP status decides, which is not enough for a system that answers 200 with a failure inside.</>],
              ['When it fires', 'Read on every run of this action.'],
              ['Example', <><em>status</em> for {'{"status": false}'}, or <em>data.status</em> when the flag sits one level down.</>]]} />
          </label>
          {readOnlyStored
            ? <input value={storePath(r.resultField ?? '')} readOnly className="is-stored" />
            : <select value={storePath(r.resultField ?? '')} disabled={locked}
                onChange={(e) => onChange({ resultField: e.target.value })}>
                <option value="">Not set &mdash; judge by HTTP status</option>
                {pathOptions(r.resultField ?? '').map((x) => <option key={x} value={x}>{x}</option>)}
              </select>}
          {/* v12.4.15 (#489): the stored field is offered even when the sample does not contain it - never hide a
              tenant's value - but SAY SO. This is the screen half of #489: his `Status` against PMWeb's `status`
              resolved to nothing, and 'not in the response' is a failure, so a booking that happened was spoken as one
              that had not. The dropdown stops new ones; this catches the ones already saved. */}
          {valid === true && (r.resultField ?? '').trim() !== '' && !paths.includes(storePath(r.resultField ?? '')) && (
            <p className="ca-resp-warn">&#9888; {storePath(r.resultField ?? '')} is not in the sample above. On a live call a field that is not in the answer counts as a FAILURE.</p>
          )}
        </div>
        <div className="f">
          <label>Means success <span className="hint">&mdash; the value that says it worked</span>
            <HelpTooltip sections={[
              ['What it does', <>The value of the result field that means it worked. Anything else is treated as a failure &mdash; never the other way round &mdash; so an answer nobody anticipated can never be read back to a caller as a confirmation.</>],
              ['When it fires', 'Compared against the result field, ignoring case, on every run.'],
              ['Why it is a list', <>v12.7.2: it was a text box, and a typo there saves cleanly, looks configured, and makes every run read as a failure. The first option is the value actually present in the sample above.</>]]} />
          </label>
          {/* v12.7.2 (#592 pt.2): A LIST OF SUGGESTIONS, NOT A CLOSED LIST. Tushar, on the first cut:
              *"in success dropdown it shows values which i am not sure from where it is pulling. what if
              external system is sending something else which is not on this list."* He is right, and the
              first version was strictly LESS capable than the text box it replaced - a system answering
              "Y" or "OK_200" could not be configured at all. A datalist suggests the same values and still
              takes anything typed, so the typo is guarded against without the door being closed. */}
          <input list={`int-resp-succ-${idx}`} value={r.successValues ?? ''} spellCheck={false}
            placeholder="pick one, or type what they send"
            readOnly={readOnlyStored} disabled={locked && !readOnlyStored}
            className={readOnlyStored ? 'is-stored' : undefined}
            onChange={(e) => onChange({ successValues: e.target.value })} />
          <datalist id={`int-resp-succ-${idx}`}>
            {successOptions(sample, storePath(r.resultField ?? ''), r.successValues ?? '')
              .map((x) => <option key={x} value={x} />)}
          </datalist>
        </div>
        <div className="f">
          <label>Failure values <span className="hint">&mdash; optional</span>
            <HelpTooltip sections={[
              ['What it does', <>Values you know mean a clean refusal. Listing them changes no routing &mdash; unlisted values already fail &mdash; but it makes the call log say the system reported a failure rather than that it answered something unrecognized.</>],
              ['When it fires', 'Compared when the result field did not match a success value.'],
              ['Example', <><em>false, 0, error</em></>]]} />
          </label>
          {/* v12.7.2 (#592 pt.2): the SAME shape as Means success beside it. It was left as a bare text box
              because listing a failure value changes no routing - anything unlisted already fails - but that
              is an argument about behavior, not about the two-mental-models problem #592 reports, and the
              two sit on one row. His words: *"for means success it shows dropdown but not for failure."* */}
          <input list={`int-resp-fail-${idx}`} value={r.failureValues ?? ''} spellCheck={false}
            placeholder="optional - what they send on a clean refusal"
            readOnly={readOnlyStored} disabled={locked && !readOnlyStored}
            className={readOnlyStored ? 'is-stored' : undefined}
            onChange={(e) => onChange({ failureValues: e.target.value })} />
          <datalist id={`int-resp-fail-${idx}`}>
            {successOptions(sample, storePath(r.resultField ?? ''), r.failureValues ?? '')
              .map((x) => <option key={x} value={x} />)}
          </datalist>
        </div>
      </div>

      {/* ══ v12.10.31 (#2314, Tushar 11/5 ~3:00 AM): "based on that response, 1 or 5, we should be able to process". The list and its
          fields are picked from the sample - when the final API arrives this is a settings change, not code. ══ */}
      {(() => {
        const arrays = sampleArrays(sample);
        const lst = r.list ?? null;
        const cur = arrays.find((a) => a.path === lst?.path);
        const fieldOpts = cur?.itemFields ?? [];
        const setList = (p: Partial<IntActionResponseList> | null) => onChange({ list: p === null ? null : { path: lst?.path ?? '', kind: lst?.kind ?? 'slots', fields: lst?.fields ?? {}, ...p } });
        return (
          <div className="ca-resp-list" style={{ margin: '10px 0 6px', padding: 10, border: '1px dashed #cbd5e1', borderRadius: 8 }}>
            <label style={{ display: 'flex', alignItems: 'center', gap: 8, fontWeight: 600 }}>
              <input type="checkbox" checked={!!lst} disabled={locked && !lst} onChange={(e) => setList(e.target.checked ? { path: arrays[0]?.path ?? '' } : null)} />
              This answer holds a list
              <HelpTooltip sections={[
                ['What it does', <>The system answers with one result or a list (up to 5 slots, or up to 5 matching patients). Pick the list and what each item holds; the workflow&rsquo;s Connect card decides what happens for One / Several / None / Error and offers slots to the caller.</>],
                ['Example', <><em>data.slots</em> &rarr; date <em>date</em>, time <em>startTime</em>.</>]]} />
            </label>
            {lst && (
              <div className="ca-resp-grid" style={{ marginTop: 8, display: 'grid', gap: 8, gridTemplateColumns: 'repeat(auto-fit, minmax(160px, 1fr))' }}>
                <div className="f"><label>The list</label>
                  <select value={lst.path} disabled={locked} onChange={(e) => setList({ path: e.target.value, fields: {} })}>
                    <option value="">Pick a list&hellip;</option>
                    {arrays.map((a) => <option key={a.path} value={a.path}>{a.path}</option>)}
                    {lst.path && !arrays.some((a) => a.path === lst.path) && <option value={lst.path}>{lst.path} (stored)</option>}
                  </select></div>
                <div className="f"><label>It lists</label>
                  <select value={lst.kind} disabled={locked} onChange={(e) => setList({ kind: e.target.value as IntActionResponseList['kind'] })}>
                    <option value="slots">Slots</option><option value="patients">Patients</option><option value="other">Other</option>
                  </select></div>
                {(['date', 'time', 'label', 'id'] as const).map((f) => (
                  <div key={f} className="f"><label>{f === 'date' ? 'Date field' : f === 'time' ? 'Time field' : f === 'label' ? 'Said as (optional)' : 'Item id (optional)'}</label>
                    <select value={lst.fields?.[f] ?? ''} disabled={locked} onChange={(e) => setList({ fields: { ...(lst.fields ?? {}), [f]: e.target.value || undefined } })}>
                      <option value="">Not set</option>
                      {fieldOpts.map((x) => <option key={x} value={x}>{x}</option>)}
                      {lst.fields?.[f] && !fieldOpts.includes(lst.fields[f]!) && <option value={lst.fields[f]}>{lst.fields[f]} (stored)</option>}
                    </select></div>
                ))}
              </div>
            )}
          </div>
        );
      })()}

      <label className="ca-body-label ca-resp-maphead">Keep from the answer <span className="hint">&mdash; so the AI can speak it back</span>
        <HelpTooltip sections={[
          ['What it does', <>Each row takes one field out of <b>their</b> answer and stores it under one of <b>our</b> tokens. The two sides are two different languages and the headers say so: on the left a path into their document, on the right a token a workflow card can speak.</>],
          ['When it fires', <>After a successful run of this action. The value is kept on the call, so a Confirm card can read back <em>{'{external.reference}'}</em> &mdash; their confirmation number, not ours.</>],
          ['Example', <><em>data.id</em> &rarr; <em>External system &rsaquo; Reference</em>.</>]]} />
      </label>
      {rows.length === 0 && !locked ? <div className="ca-resp-note">Nothing mapped yet. Without a mapping the call still runs &mdash; the answer is simply not kept.</div> : null}
      {/* v12.4.16 (#498): the column headers that replaced the `response.` prefix. Rendered only when there is a
          row to head, so an empty block does not show two labels over nothing. */}
      {rows.length > 0 && (
        <div className="ca-map-row ca-map-head" aria-hidden="true">
          <span className="ca-map-col">Their field</span>
          <span className="ca-map-arrow">&rarr;</span>
          <span className="ca-map-col">Our token</span>
          <span />
        </div>
      )}
      {rows.map((row, i) => (
        <div key={i} className="ca-map-row">
          {readOnlyStored
            ? <input className="ca-map-path is-stored" readOnly value={storePath(row.path)} />
            : <select className="ca-map-path" value={storePath(row.path)} disabled={locked}
                onChange={(e) => setRow(i, { path: e.target.value })}>
                <option value="">Pick a field&hellip;</option>
                {pathOptions(row.path).map((x) => <option key={x} value={x}>{x}</option>)}
              </select>}
          <span className="ca-map-arrow" aria-hidden="true">&rarr;</span>
          <select className="ca-map-token" value={row.token} disabled={locked}
            onChange={(e) => setRow(i, { token: e.target.value })}>
            <option value="">Not set</option>
            {tokens.groups.map((g) => (
              <optgroup key={g.label} label={g.label}>
                {g.tokens.map((t) => <option key={t} value={t}>{tokens.labelOf(t) ?? `{${t}}`}</option>)}
              </optgroup>
            ))}
          </select>
          {!readOnlyStored && (
            <button type="button" className="icon-btn danger" aria-label="Remove mapping"
              onClick={() => onChange({ map: rows.filter((_, j) => j !== i) })}><XIcon /></button>
          )}
        </div>
      ))}
      {!locked && (
        <button type="button" className="btn-soft" style={{ marginTop: 8 }}
          onClick={() => onChange({ map: [...rows, { path: '', token: '' }] })}><PlusIcon /> Add mapping</button>
      )}
    </div>
  );
}

function ConnectedSystemDrawer({ system, saving, onClose, onSave }: {
  system: IntConnectedSystem | null; saving: boolean;
  onClose: () => void; onSave: (body: ConnBody, id: string | null) => void;
}) {
  const tokens = useIntegrationTokens();   // v12.4.12 (#482)
  const { customFields: tieFields } = useVocabulary();   // v12.10.10 (#1406 C6)
  const editing = system != null;
  const cfg0 = (system?.config ?? {}) as Record<string, unknown>;
  const [name, setName] = useState(system?.name ?? '');
  const [type, setType] = useState(system?.type ?? 'rest');
  const [authMethod, setAuthMethod] = useState(system?.authMethod ?? 'bearer');
  const [secret, setSecret] = useState('');
  const [showSecret, setShowSecret] = useState(false);
  // Per-card toggle owns the enabled flag (applies immediately); the drawer preserves it.
  const enabled = system?.enabled ?? true;
  const [baseUrl, setBaseUrl] = useState(system?.baseUrl ?? '');
  const [fhirVersion, setFhirVersion] = useState(system?.fhirVersion ?? 'R4');
  const [actions, setActions] = useState<IntAction[]>(structuredClone(system?.actions ?? []));
  // v12.4.12 (#482): OAuth 2.0 client credentials. client_secret is the Credential field below.
  const [oauthTokenUrl, setOauthTokenUrl] = useState(system?.oauthTokenUrl ?? '');
  const [oauthGrantType, setOauthGrantType] = useState(system?.oauthGrantType || OAUTH_DEFAULT_GRANT);
  const [oauthClientId, setOauthClientId] = useState(system?.oauthClientId ?? '');
  const [oauthScope, setOauthScope] = useState(system?.oauthScope ?? '');
  // HL7 / SFTP live in config
  const [hl7Endpoint, setHl7Endpoint] = useState((cfg0.hl7Endpoint as string) ?? '');
  const [hl7Messages, setHl7Messages] = useState((cfg0.hl7Messages as string) ?? 'ADT, SIU');
  const [sftpHost, setSftpHost] = useState((cfg0.sftpHost as string) ?? '');
  const [sftpPort, setSftpPort] = useState(String((cfg0.sftpPort as number) ?? 22));
  const [sftpUser, setSftpUser] = useState((cfg0.sftpUser as string) ?? '');
  const [sftpPath, setSftpPath] = useState((cfg0.sftpPath as string) ?? '/inbound');

  // v12.4.13 (#486): the tests live here now, and they run against WHAT IS ON SCREEN. Only Save writes to the DB.
  const [tokenTest, setTokenTest] = useState<TestResult | 'pending' | null>(null);
  const [actionTest, setActionTest] = useState<Record<number, TestResult | 'pending'>>({});
  const [openTest, setOpenTest] = useState<Record<number, boolean>>({});
  // v12.4.15 (#492): which action's editor is on screen. The pill row owns this.
  const [selAction, setSelAction] = useState(0);
  const [samples, setSamples] = useState<Record<string, string>>({});
  const testId = system?.id ?? '0';   // 0 = never saved; the server then has no row to fall back to

  // The connection as the drawer currently shows it. secret blank = "use the stored one".
  const onScreen = () => ({
    authMethod: type === 'sftp' ? 'none' : authMethod,
    baseUrl: baseUrl.trim(),
    oauthTokenUrl: oauthTokenUrl.trim(),
    oauthGrantType: oauthGrantType.trim(),
    oauthClientId: oauthClientId.trim(),
    oauthScope: oauthScope.trim(),
    secret: secret.trim(),
  });

  async function runTokenTest() {
    setTokenTest('pending');
    try {
      setTokenTest(await api.post<TestResult>(`/t2/settings/integrations/connected-systems/${testId}/test`, { ...onScreen(), mode: 'token' }));
    } catch {
      setTokenTest({ ok: false, status: 0, detail: 'Test failed — the token endpoint could not be reached.' });
    }
  }

  async function runActionTest(i: number) {
    const a = actions[i];
    const toks = requestTokens(a.path ?? '', a.body ?? '').filter((t) => !isOrgToken(t));
    setActionTest((m) => ({ ...m, [i]: 'pending' }));
    try {
      const r = await api.post<TestResult>(`/t2/settings/integrations/connected-systems/${testId}/test`, {
        ...onScreen(), mode: 'action',
        method: a.method, path: (a.path ?? '').trim(), contentType: (a.contentType ?? '').trim(),
        // v12.5.3 (#542): test what a save would store, not what the DOM happens to hold.
        body: normalizeBodyWhitespace(a.body ?? ''),
        // v12.5.2 (#496): the drawer test MUST send the same formats a live call uses, or the two render
        // different bodies from the same values - which is the whole "works in the test, fails on a call"
        // class of bug this item exists to end.
        formats: a.formats ?? {},
        samples: Object.fromEntries(toks.map((t) => [t, samples[t.toLowerCase()] ?? wireSampleFor(t, tokens.typeOf(t))])),
      });
      setActionTest((m) => ({ ...m, [i]: r }));
      // v12.4.15 (#492): remember the outcome ON THE ACTION, with a fingerprint of what was tested. It reaches the
      // database only when he presses Save - the 12.4.13 rule stands: a test runs against what is on screen and
      // writes nothing by itself.
      setActions((list) => list.map((x, j) => (j === i
        ? { ...x, lastTest: { at: new Date().toISOString(), ok: !!r.ok, status: r.status ?? 0, fp: testFingerprint(x) } }
        : x)));
    } catch {
      setActionTest((m) => ({ ...m, [i]: { ok: false, status: 0, detail: 'Test failed — the endpoint could not be reached.' } }));
    }
  }

  const hasStoredSecret = system?.hasSecret ?? false;
  const nameValid = name.trim().length > 0;
  const usesActions = connUsesActions(type);
  const isOAuth = usesActions && authMethod === 'oauth2';   // v12.4.12 (#482)

  const addAction = () => setActions((a) => [...a, { name: '', method: 'GET', path: '', desc: '' }]);
  const removeAction = (i: number) => setActions((a) => a.filter((_, j) => j !== i));
  const setAction = (i: number, patch: Partial<IntAction>) => setActions((a) => a.map((x, j) => (j === i ? { ...x, ...patch } : x)));
  // v12.4.12 (#482): insertToken / insertBodyToken (identity-identifier chips) removed - the TokenPicker inserts.
  const hasBody = (m: string) => { const u = (m || '').toUpperCase(); return u === 'POST' || u === 'PUT' || u === 'PATCH'; };

  // v12.5.2 (#533): AN UNPARSEABLE JSON BODY CANNOT BE SAVED.
  //
  // Nothing anywhere validated this - not here, not in the API, not before sending. The only check in the
  // whole codebase was IsValidContentType, which inspects the HEADER, not the content. So a body broken by
  // hand-editing a token saved cleanly, went out on a live call, and the other system answered 400 - which
  // reads as "the data was wrong" rather than "the request was malformed". Tushar hit exactly this: he typed
  // a date in by hand and the test failed; he re-inserted the token from the picker and it passed.
  //
  // The panel was ALREADY telling him, quietly: "The request body is not valid JSON yet" renders on this same
  // condition. It was a note where it should have been a stop.
  const badBodies = actions
    .map((a, idx) => ({ idx, a }))
    .filter(({ a }) =>
      hasBody(a.method)
      && (a.body ?? '').trim() !== ''
      && /json/i.test(a.contentType ?? 'application/json')
      && bodyFields(a.body ?? '') === null);
  const bodiesValid = badBodies.length === 0;

  // v12.10.10 (#1406 C6): {provider.id} in a body sends the chosen entry's id for THIS system only when provider.id is tied to a
  // list's Their id. Untied, nothing fills it - named here, and Test this action shows the gap as an unresolved token.
  // v12.10.28 (#2209): {provider.id} / {location.id} are gone - {provider.externalId} / {location.externalId} /
  // {request.TypeExternalID} send this system's id (Translations). An old token left in a body is named here.
  const untiedIds = Array.from(new Set(actions.flatMap((a) => Array.from((a.body ?? '').matchAll(/\{\s*([A-Za-z][A-Za-z0-9_]*\.id)\s*\}/g)).map((m) => m[1]))))
    .filter((t) => /^(provider|location)\.id$/i.test(t) || !Object.entries(tieFields ?? {}).some(([k, f]) => k.toLowerCase() === t.toLowerCase() && !!f?.listKey));
  const submit = () => {
    if (!nameValid || !bodiesValid) return;
    // SFTP password is the "secret". For non-SFTP the secret is the auth credential.
    const secretOut = secret.trim() !== '' ? secret : (hasStoredSecret ? SECRET_KEEP : '');
    const config: Record<string, unknown> =
      type === 'hl7' ? { hl7Endpoint: hl7Endpoint.trim(), hl7Messages: hl7Messages.trim() }
      : type === 'sftp' ? { sftpHost: sftpHost.trim(), sftpPort: Number(sftpPort) || 22, sftpUser: sftpUser.trim(), sftpPath: sftpPath.trim() }
      : {};
    onSave({
      name: name.trim(),
      type,
      authMethod: type === 'sftp' ? 'none' : authMethod,
      secret: secretOut,
      baseUrl: usesActions ? baseUrl.trim() : '',
      fhirVersion: type === 'fhir' ? fhirVersion : 'R4',
      config,
      // v12.5.3 (#542): save the CLEANED body. The runner normalizes too, but a stored value that parses
      // everywhere is worth more than one repaired on every call - and it makes the next Run test honest.
      actions: usesActions ? actions.map((a) => (a.body ? { ...a, body: normalizeBodyWhitespace(a.body) } : a)) : [],
      enabled,
      // v12.4.12 (#482): the API keeps these only while the connection is oauth2.
      oauthTokenUrl: isOAuth ? oauthTokenUrl.trim() : '',
      oauthGrantType: isOAuth ? (oauthGrantType.trim() || OAUTH_DEFAULT_GRANT) : '',
      oauthClientId: isOAuth ? oauthClientId.trim() : '',
      oauthScope: isOAuth ? oauthScope.trim() : '',
    }, system?.id ?? null);
  };

  const secretLabel = type === 'sftp' ? 'Password' : isOAuth ? 'client_secret' : 'Credential (token / key / secret)';
  const secretPlaceholder = hasStoredSecret ? 'Saved — leave blank to keep' : (type === 'sftp' ? 'SFTP password' : isOAuth ? 'Client secret issued with the client_id' : 'Token, API key, or client secret');

  return (
    <Drawer onClose={onClose} title={editing ? 'Edit integration' : 'Add integration'} subtitle="Connect an external system and define how the AI reaches it."
      footer={<>
        {untiedIds.length > 0 && (
          <span className="int-save-warn" role="status" title="Use {provider.externalId} / {location.externalId} / {request.TypeExternalID} - the ids come from Translations">
            &#9888; {untiedIds.map((t) => `{${t}}`).join(', ')} {untiedIds.length === 1 ? 'is' : 'are'} not filled any more - use the external ID tokens (Translations)
          </span>
        )}
        {!bodiesValid && (
          <span className="int-save-block" role="alert">
            &#9888; {badBodies.length === 1 ? 'One action has' : `${badBodies.length} actions have`} a request body that is not valid JSON
            {badBodies.length === 1 ? ` (${actions[badBodies[0].idx]?.name || 'unnamed action'})` : ''} &mdash; fix it before saving.
          </span>
        )}
        <button type="button" className="mc" onClick={onClose}>Cancel</button>
        <button type="button" className="ma" disabled={!nameValid || !bodiesValid || saving} onClick={submit}><SaveIcon /> {saving ? 'Saving…' : 'Save integration'}</button>
      </>}>
      <div className="f"><label>Connection name<HelpTooltip sections={[['What it does', 'A label for this integration, shown on the connection card. It is for your reference and is not sent to the external system.'], ['When it fires', 'Used only in this admin UI — it appears on the card and in save/remove toasts.'], ['Example', <>Name it <em>Practice EHR</em> or <em>Scheduling API</em> so the card reads clearly in the grid.</>]]} /></label><input value={name} onChange={(e) => setName(e.target.value)} placeholder="e.g. Practice EHR" /></div>
      <div className="fr">
        <div className="f"><label>Type <span className="hint">— sets the connectivity method</span><HelpTooltip sections={[['What it does', 'Chooses how the platform talks to this system, which changes the fields below. REST and FHIR are request/response APIs the AI calls per action; HL7 and SFTP are message/file feeds with no per-call actions.'], ['When it fires', 'Applied on save. It determines which connectivity fields (Base URL, FHIR version, MLLP endpoint, or SFTP host) and whether an Actions list are shown.'], ['Example', <>Pick <em>REST API</em> for a JSON scheduling API, or <em>FHIR</em> to talk to an EHR’s FHIR server with a version and actions.</>]]} /></label>
          <select value={type} onChange={(e) => setType(e.target.value)}>{CONN_TYPES.map(([v, l]) => <option key={v} value={v}>{l}</option>)}</select>
        </div>
        {type !== 'sftp' ? (
          <div className="f"><label>Auth method<HelpTooltip sections={[['What it does', 'How the platform authenticates to this system. The credential you enter below is interpreted according to this choice. SFTP uses a password instead and hides this field.'], ['When it fires', 'Applied on save and used on each outbound call once integrations are active. It labels how the stored credential is presented to the system.'], ['Example', <><em>Bearer token</em> sends the credential as a bearer token; <em>API key header</em> sends it as a key header; choose <em>None</em> for an open endpoint.</>]]} /></label><select value={authMethod} onChange={(e) => setAuthMethod(e.target.value)}>{CONN_AUTH.map(([v, l]) => <option key={v} value={v}>{l}</option>)}</select></div>
        ) : <div className="f" />}
      </div>

      {/* type-specific connectivity fields */}
      {(type === 'rest' || type === 'fhir') && (
        <>
          <div className="f"><label>Base URL <span className="hint">— leave blank to keep as “not configured”</span><HelpTooltip sections={[['What it does', 'The root address of the API. Each action’s path is appended to this base. Leave it blank to keep the connection parked as “not configured”.'], ['When it fires', <>Once integrations are active, every action call is made against this base + the action path. It also drives status — a connection reads <em>Connected</em> only when its required fields (including this) are present.</>], ['Example', <><em>https://api.example.com</em> — an action path of <em>/appointments/available</em> resolves to https://api.example.com/appointments/available.</>]]} /></label><div className="with-ic"><PlugIcon /><input value={baseUrl} onChange={(e) => setBaseUrl(e.target.value)} placeholder="https://api.example.com" /></div></div>
          {type === 'fhir' && (
            <div className="fr"><div className="f"><label>FHIR version<HelpTooltip sections={[['What it does', 'The FHIR release this server speaks, so action paths and payloads target the right resource shapes.'], ['When it fires', 'Stored with the connection and applied to FHIR calls once integrations are active. It only appears for the FHIR type.'], ['Example', <>Choose <em>R4</em> for most current EHR FHIR endpoints; pick <em>STU3</em> only if the server predates R4.</>]]} /></label><select value={fhirVersion} onChange={(e) => setFhirVersion(e.target.value)}>{['R4', 'R4B', 'R5', 'STU3'].map((v) => <option key={v} value={v}>{v}</option>)}</select></div><div className="f" /></div>
          )}
        </>
      )}
      {type === 'hl7' && (
        <div className="fr">
          <div className="f"><label>MLLP endpoint<HelpTooltip sections={[['What it does', 'The host:port where HL7 v2 messages are exchanged over MLLP. HL7 is a message feed, so there are no per-call actions to define.'], ['When it fires', <>Stored now; the platform will ingest messages on this endpoint once the HL7 transport runtime ships. It also drives status — a connection reads <em>Connected</em> only when its required fields are present.</>], ['Example', <><em>ehr.example.com:2575</em> — the standard MLLP listener host and port for your interface engine.</>]]} /></label><input value={hl7Endpoint} onChange={(e) => setHl7Endpoint(e.target.value)} placeholder="host:port" /></div>
          <div className="f"><label>Message types<HelpTooltip sections={[['What it does', 'The HL7 v2 message families this feed handles, as a comma-separated list. Informational — it documents what the endpoint accepts.'], ['When it fires', 'Stored with the connection and used once the HL7 transport runtime ships to scope which messages are processed.'], ['Example', <><em>ADT, SIU</em> — patient admit/discharge/transfer events and scheduling messages.</>]]} /></label><input value={hl7Messages} onChange={(e) => setHl7Messages(e.target.value)} placeholder="ADT, SIU" /></div>
        </div>
      )}
      {type === 'sftp' && (
        <>
          <div className="fr">
            <div className="f"><label>Host<HelpTooltip sections={[['What it does', 'The SFTP server hostname the platform connects to. SFTP is a batch file feed, so there are no per-call actions to define.'], ['When it fires', <>Stored now; the platform will poll this host on a schedule once the SFTP transport runtime ships. It contributes to status — a connection reads <em>Connected</em> only when its required fields are present.</>], ['Example', <><em>sftp.example.com</em> — your file-drop server’s hostname.</>]]} /></label><input value={sftpHost} onChange={(e) => setSftpHost(e.target.value)} placeholder="sftp.example.com" /></div>
            <div className="f"><label>Port<HelpTooltip sections={[['What it does', 'The TCP port for the SFTP connection. Defaults to 22, the standard SFTP port.'], ['When it fires', 'Used with the host when the platform polls this feed once the SFTP transport runtime ships.'], ['Example', <>Leave it at <em>22</em> unless your server listens on a non-standard port such as <em>2222</em>.</>]]} /></label><input value={sftpPort} inputMode="numeric" onChange={(e) => setSftpPort(e.target.value.replace(/[^0-9]/g, ''))} placeholder="22" /></div>
          </div>
          <div className="fr">
            <div className="f"><label>Username<HelpTooltip sections={[['What it does', 'The account name used to log in to the SFTP server. Its password is entered in the Password field below.'], ['When it fires', 'Used to authenticate the SFTP session when the platform polls this feed once the transport runtime ships.'], ['Example', <><em>feed-user</em> — a dedicated service account your file provider issued for this drop.</>]]} /></label><input value={sftpUser} onChange={(e) => setSftpUser(e.target.value)} placeholder="feed-user" /></div>
            <div className="f" />
          </div>
          <div className="f"><label>Remote path<HelpTooltip sections={[['What it does', 'The directory on the SFTP server that the platform reads files from.'], ['When it fires', 'The path the poller lists and pulls files from once the SFTP transport runtime ships.'], ['Example', <><em>/inbound</em> — the folder where your provider deposits batch files for pickup.</>]]} /></label><input value={sftpPath} onChange={(e) => setSftpPath(e.target.value)} placeholder="/inbound" /></div>
        </>
      )}

      {/* v12.4.12 (#482): OAuth 2.0 client credentials. The platform posts these (form-encoded) to the Token URL
          to get an access token, then sends that token on the action calls. client_secret is the field below. */}
      {isOAuth && (
        <>
          <div className="subhead" style={{ marginTop: 18 }}>OAuth 2.0 client credentials <span className="hint">— used to fetch an access token</span></div>
          <div className="f"><label>Token URL<HelpTooltip sections={[['What it does', 'The OAuth 2.0 token endpoint. The platform sends grant_type, client_id, client_secret and scope here (form-encoded) and receives an access token.'], ['When it fires', 'Before an action call on this connection - including Test connection, which fetches its own token from these saved values.'], ['Example', <><em>https://auth.example.com/oauth2/token</em></>]]} /></label><div className="with-ic"><LockIcon /><input value={oauthTokenUrl} onChange={(e) => setOauthTokenUrl(e.target.value)} placeholder="https://auth.example.com/oauth2/token" /></div>
            {/* v12.4.13 (#485): said once, where it matters - the token host need not be the API host. */}
            <p className="int-field-hint">A full URL. It does not have to be on the same host as the Base URL — the token comes from here, the action calls go to the Base URL.</p>
          </div>
          <div className="fr">
            <div className="f"><label>grant_type<HelpTooltip sections={[['What it does', 'The OAuth 2.0 grant the token endpoint expects. Server-to-server integrations use client_credentials.'], ['When it fires', 'Sent with every token request.'], ['Example', <><em>client_credentials</em></>]]} /></label><input value={oauthGrantType} onChange={(e) => setOauthGrantType(e.target.value)} placeholder={OAUTH_DEFAULT_GRANT} /></div>
            <div className="f"><label>client_id<HelpTooltip sections={[['What it does', 'The client identifier the provider issued for this integration. It is not a secret and is shown again when you edit.'], ['When it fires', 'Sent with every token request, together with client_secret.'], ['Example', <><em>vs-harlemm-scheduler</em></>]]} /></label><input value={oauthClientId} onChange={(e) => setOauthClientId(e.target.value)} placeholder="Client ID" autoComplete="off" /></div>
          </div>
          <div className="f"><label>scope <span className="hint">— optional, space-separated</span><HelpTooltip sections={[['What it does', 'The permissions requested with the token. Leave blank if the provider does not use scopes; a blank scope is not sent.'], ['When it fires', 'Sent with every token request when filled in.'], ['Example', <><em>appointments.write patients.read</em></>]]} /></label><input value={oauthScope} onChange={(e) => setOauthScope(e.target.value)} placeholder="appointments.write" /></div>
          {/* v12.4.13 (#486): test the auth on its own - his ladder starts here. Uses the fields above as typed;
              a blank client_secret means the saved one. */}
          <div className="int-test-row">
            <button type="button" className="btn-soft" onClick={runTokenTest} disabled={tokenTest === 'pending'}>
              <PlugIcon /> {tokenTest === 'pending' ? 'Requesting a token…' : 'Test token'}
            </button>
            <span className="int-test-note">Tries what is on this screen. Nothing is saved.</span>
          </div>
          {tokenTest && tokenTest !== 'pending' && <TestResultView r={tokenTest as TestResult} />}
        </>
      )}

      {/* secret (§C1) */}
      <div className="f">
        <label>{secretLabel}<HelpTooltip sections={[['What it does', 'The credential used to authenticate to this system — a token, API key, client secret, or (for SFTP) the account password, matching the Auth method above. It is AES-encrypted at rest and never returned to this screen; the field only reflects whether a secret is saved.'], ['When it fires', 'Presented on each outbound call once integrations are active, per the Auth method. When editing, leave it blank to keep the stored secret; type a value to replace it.'], ['Example', <>Paste your <em>client secret</em> or <em>API key</em>. On a later edit the field stays empty and reads “Saved — leave blank to keep”.</>]]} /></label>
        <div className="secret-row">
          <input type={showSecret ? 'text' : 'password'} className="secret-input" value={secret} onChange={(e) => setSecret(e.target.value)} placeholder={secretPlaceholder} autoComplete="new-password" />
          <button type="button" className="secret-toggle" onClick={() => setShowSecret((v) => !v)} aria-label={showSecret ? 'Hide value' : 'Show value'}>{showSecret ? <EyeOffIcon /> : <EyeIcon />}</button>
        </div>
      </div>
      <div className="conn-secret-note"><LockIcon /><span>Credentials (tokens, keys, client secrets, passwords) are stored securely and never shown again. Leave blank to keep the saved value.</span></div>

      {/* actions (REST/FHIR) or feed note (HL7/SFTP) */}
      {usesActions ? (
        <>
          <div className="subhead" style={{ marginTop: 18 }}>Actions <span className="hint">— the calls the AI can make on this connection</span><HelpTooltip sections={[['What it does', <>Defines each call the AI may make on this connection: a name, an HTTP method, a path appended to the Base URL, and a description the AI reads to decide when to use it. A path may embed <em>{'{token}'}</em> placeholders that bind to your org’s captured-identity keys (e.g. <em>member_id</em>, <em>date_of_birth</em>) — use “Insert a captured value” so the token names match exactly.</>], ['When it fires', <>Once integrations are active, the AI calls the action mid-conversation when its description fits the moment, substituting captured values into any tokens. Actions apply only to REST and FHIR connections.</>], ['Example', <>A <em>Check availability</em> action, <em>GET</em> <em>/appointments?member={'{member_id}'}</em>, described as “Find open appointment slots for the caller.”</>]]} /></div>
          {/* v12.4.15 (#492): A PILL ROW, NOT A FIVE-DEEP SCROLL. Tushar, 2026-09-19: "right now it's a very long
              scroll of 4-5 methods. what we need to do is, for clear identification we can follow request type kind of
              design where each action can be visible and if it is tested then it shows status along with the action."
              So this is the Request node's request-type row, applied here: one pill per action, the editor for the
              SELECTED one below, and a readiness readout. Five actions now cost one screen. */}
          <div className="ca-pillrow">
            <div className="ca-pills" role="tablist" aria-label="Actions">
              {actions.map((a, i) => {
                const badge = actionBadge(a);
                return (
                  <button key={i} type="button" role="tab" aria-selected={selAction === i}
                    className={`ca-pill${selAction === i ? ' is-on' : ''}`} onClick={() => setSelAction(i)}
                    title={badge.title}>
                    <span className="ca-pill-name">{(a.name ?? '').trim() || 'Untitled action'}</span>
                    <span className={`ca-pill-dot is-${badge.kind}`} aria-hidden="true" />
                    <span className="sr-only">{badge.title}</span>
                  </button>
                );
              })}
            </div>
            <div className="ca-pillrow-right">
              {actions.length > 0 && (
                <span className="ca-ready-count" title="Ready means it has a path, a body where the method needs one, and a result rule.">
                  {actions.filter(actionReady).length} of {actions.length} ready
                </span>
              )}
              <button type="button" className="btn-soft" onClick={addAction}><PlusIcon /> Add action</button>
            </div>
          </div>

          {actions.length === 0 ? <div className="conn-empty sm">No actions yet.</div> : (() => {
            const i = Math.min(selAction, actions.length - 1);
            const a = actions[i];
            const badge = actionBadge(a);
            return (
              <div className="conn-action">
                <div className="ca-row1">
                  <input className="ca-name" placeholder="Action name (e.g. Book appointment)" value={a.name} onChange={(e) => setAction(i, { name: e.target.value })} />
                  <button type="button" className="icon-btn danger ca-del" onClick={() => { removeAction(i); setSelAction(0); }} aria-label="Remove action"><XIcon /></button>
                </div>
                <div className="ca-row2">
                  <select className="ca-method" value={a.method} onChange={(e) => setAction(i, { method: e.target.value })}>{['GET', 'POST', 'PUT', 'PATCH', 'DELETE'].map((m) => <option key={m} value={m}>{m}</option>)}</select>
                  {/* v12.4.12 (#482): canonical vocabulary, shown with the tenant's labels. */}
                  <div className="ca-path ai-agent-panel int-tokfield">
                    <TokenPicker value={a.path} onChange={(v) => setAction(i, { path: v })} rows={1} placeholder="/appointments?member={subject.memberId}"
                      groups={tokens.groups} labelOf={tokens.labelOf} aliasOf={tokens.aliasOf} chipTest={isRequestToken} />
                  </div>
                </div>
                <input className="ca-desc" placeholder="What this action does (shown to the AI)" value={a.desc} onChange={(e) => setAction(i, { desc: e.target.value })} />
                {/* v12.2.23.0 (#150): for POST/PUT/PATCH, a request-body template composed with captured values. */}
                {hasBody(a.method) && (
                  <div className="ca-body-wrap">
                    <div className="ca-ctype">
                      <label className="ca-body-label" htmlFor={`ca-ctype-${i}`}>Content-Type</label>
                      <input id={`ca-ctype-${i}`} className="ca-ctype-input" list="int-content-types" value={a.contentType ?? ''} placeholder="application/json"
                        onChange={(e) => setAction(i, { contentType: e.target.value })} spellCheck={false} />
                    </div>
                    <label className="ca-body-label">Request body <span className="hint">&mdash; sent as the {a.method.toUpperCase()} content. Insert captured values as tokens.</span></label>
                    <div className="ai-agent-panel int-tokfield int-tokbody">
                      <TokenPicker value={a.body ?? ''} onChange={(v) => setAction(i, { body: v })} rows={6}
                        placeholder={'{\n  "memberId": "{subject.memberId}",\n  "dob": "{subject.dob}"\n}'}
                        groups={tokens.groups} labelOf={tokens.labelOf} aliasOf={tokens.aliasOf} chipTest={isRequestToken} />
                    </div>
                  </div>
                )}

                {/* v12.4.13 (#486): this action's own test, against what is on screen. v12.4.15 (#492): and it says
                    when it last ran - his ask, "if we can display when it was last tested next to test this action". */}
                <div className="int-test-row">
                  <button type="button" className="btn-soft" onClick={() => setOpenTest((m) => ({ ...m, [i]: !m[i] }))}>
                    <PlugIcon /> {openTest[i] ? 'Hide test' : 'Test this action'}
                  </button>
                  {a.lastTest ? <span className={`ca-lasttest is-${badge.kind}`}>{badge.title}</span>
                    : isOAuth ? <span className="int-test-note">Fetches a token first, then calls this action.</span> : null}
                </div>
                {openTest[i] && (() => {
                  // v12.4.16 (#495): THE PANEL NAMES EVERY FIELD THE REQUEST SENDS. Only the token ones can be
                  // filled from a call, but every one of them is listed - literals read-only and tagged - because a
                  // field that is missing from this list reads as a field that is not being sent. The body's own key
                  // order is kept, so the rows hold still while he types.
                  const known = new Set(tokens.known.map((t) => canonToken(t).toLowerCase()));
                  const fillable = (t: string) => !isOrgToken(t) && known.has(canonToken(t).toLowerCase());
                  const found = requestTokens(a.path ?? '', a.body ?? '');
                  const orgToks = found.filter(isOrgToken);
                  const strays = found.filter((t) => !isOrgToken(t) && !fillable(t));
                  const val = (t: string) => samples[t.toLowerCase()] ?? wireSampleFor(t, tokens.typeOf(t));
                  const setVal = (t: string, v: string) => setSamples((m) => ({ ...m, [t.toLowerCase()]: v }));
                  // v12.5.2 (#496): the format is stored against the CANONICAL token key, so it survives the
                  // body being rewritten with a different alias for the same field.
                  const fmtKey = (t: string) => canonToken(t);
                  const fmtOf = (t: string) => (a.formats ?? {})[fmtKey(t)] ?? '';
                  const setFmt = (t: string, v: string) => {
                    const next = { ...(a.formats ?? {}) };
                    if (v) next[fmtKey(t)] = v; else delete next[fmtKey(t)];
                    setAction(i, { formats: next });
                  };
                  // v12.5.3 (#544): `field` is the JSON key (or the URL token) this row fills; `label` is the
                  // tenant's word for the vocabulary field filling it. Both, always, on one line.
                  const tokRow = (t: string, key: string, field?: string) => {
                    const ty = (tokens.typeOf(t) ?? '').toLowerCase();
                    const isDate = ty === 'date', isTime = ty === 'time';
                    const canonical = fillable(t) ? val(t) : '';
                    return (
                      <SampleRow key={key} label={tokens.labelOf(t) ?? `{${t}}`} field={field ?? `{${t}}`}
                        type={ty || 'not specified'} title={`{${t}}`}
                        editable={fillable(t)} value={fillable(t) ? val(t) : `{${t}}`}
                        tag={isOrgToken(t) ? 'from Organization' : fillable(t) ? undefined : 'sent as written'}
                        onChange={(v) => setVal(t, v)}
                        format={fillable(t) && (isDate || isTime) ? {
                          type: isDate ? 'date' : 'time',
                          value: fmtOf(t),
                          canonical,
                          options: isDate ? DATE_FORMATS : TIME_FORMATS,
                          sent: previewWire(ty, canonical, fmtOf(t)),
                          onChange: (v) => setFmt(t, v),
                        } : undefined} />
                    );
                  };
                  const pathToks = requestTokens(a.path ?? '');
                  const fields = hasBody(a.method) ? bodyFields(a.body ?? '') : null;
                  const bodyToks = hasBody(a.method) ? requestTokens(a.body ?? '') : [];
                  const hasBodyRows = fields ? fields.length > 0 : bodyToks.length > 0;
                  return (
                    <div className="ct-samples">
                      {(pathToks.length > 0 || hasBodyRows) && (
                        <div className="ct-samples-head">Sample values <span className="hint">&mdash; every field this request sends. Token fields are filled from the call; fixed values go out as written.</span></div>
                      )}
                      {/* v12.5.3 (#544): name the columns once, above the rows, instead of a "SENDS AS" label
                          repeated beside every select. */}
                      {(pathToks.length > 0 || hasBodyRows) && (
                        <div className="ct-sample-cols" aria-hidden="true">
                          <span>Label</span><span>Field</span><span>Type</span><span>Format</span><span>Value sent</span>
                        </div>
                      )}
                      {pathToks.length > 0 && <div className="ct-sample-group">URL</div>}
                      {pathToks.map((t) => tokRow(t, `p:${t}`))}
                      {hasBodyRows && <div className="ct-sample-group">Request body</div>}
                      {fields
                        ? fields.map((f) => {
                            if (f.tokens.length === 0) {
                              return <SampleRow key={`b:${f.path}`} label={'\u2014'} field={f.path} type="fixed" title={f.path} editable={false} value={f.raw} />;
                            }
                            if (f.tokens.length === 1 && WHOLE_TOKEN_RE.test(f.raw)) return tokRow(f.tokens[0], `b:${f.path}`, f.path);
                            // text with tokens inside it: show what is sent, then the tokens it still needs filled.
                            return (
                              <div key={`b:${f.path}`} className="ct-sample-compose">
                                <SampleRow label={'\u2014'} field={f.path} type="mixed" title={f.path} editable={false} value={f.raw} />
                                {f.tokens.filter(fillable).map((t) => tokRow(t, `b:${f.path}:${t}`, `\u21b3 ${f.path}`))}
                              </div>
                            );
                          })
                        : bodyToks.map((t) => tokRow(t, `bt:${t}`))}
                      {hasBody(a.method) && fields === null && (a.body ?? '').trim() !== '' && (
                        <div className="ct-sample-warn">&#9888; The request body is not valid JSON, so its fields cannot be named and this action <strong>cannot be saved</strong> until it parses. The tokens above are what a call would fill. A token inserted from the picker never breaks the syntax &mdash; hand-editing one usually does.</div>
                      )}
                      {orgToks.length > 0 && <div className="ct-sample-note">{orgToks.map((t) => `{${t}}`).join(', ')} &mdash; filled from your Organization settings.</div>}
                      {strays.length > 0 && <div className="ct-sample-warn">&#9888; {strays.map((t) => `{${t}}`).join(', ')} {strays.length === 1 ? 'is' : 'are'} not in the vocabulary &mdash; a call cannot fill {strays.length === 1 ? 'it' : 'them'}, so {strays.length === 1 ? 'it is' : 'they are'} sent as written.</div>}
                      <div className="int-test-row">
                        <button type="button" className="btn-soft is-primary" onClick={() => runActionTest(i)} disabled={actionTest[i] === 'pending'}>
                          <SendIcon /> {actionTest[i] === 'pending' ? 'Testing\u2026' : 'Run test'}
                        </button>
                        <span className="int-test-note">Sends a real request. The result is kept when you save.</span>
                      </div>
                      {actionTest[i] && actionTest[i] !== 'pending' && <TestResultView r={actionTest[i] as TestResult} />}
                    </div>
                  );
                })()}

                {/* v12.4.14 (#85a): what their answer means, and which parts of it we keep. */}
                <ResponseBlock idx={i} value={a.response} tokens={tokens}
                  lastResponse={(actionTest[i] && actionTest[i] !== 'pending') ? (actionTest[i] as TestResult).response : undefined}
                  onChange={(patch) => setAction(i, { response: { ...(a.response ?? {}), ...patch } })} />
              </div>
            );
          })()}
          <datalist id="int-content-types">{CONTENT_TYPES.map((c) => <option key={c} value={c} />)}</datalist>
        </>
      ) : (
        <div className="conn-feed-note"><DownloadIcon /><span>{type === 'hl7' ? 'HL7 is a message feed — the platform ingests ADT/SIU messages on the endpoint above. No per-call actions to define here.' : 'SFTP is a batch file feed — the platform polls the path above on a schedule. No per-call actions to define here.'}</span></div>
      )}
    </Drawer>
  );
}

/* ── Connection tests, in the editor (v12.4.13 #486) ────────────────────── */
// The 12.4.12 drawer put the action picker, a URL box, sample values and results in a screen of their own.
// Tushar, 2026-09-18: "it lanuches awkard screen to test connection... in the configuration itself, there should
// be test connection for auth, each action that is defined there." So a test now sits beside the thing it tests,
// and the URL box is gone - an action test uses the Base URL plus that action's own saved path.
export type TestResult = {
  ok: boolean; status: number; detail: string; response?: string;
  stage?: 'token' | 'action';
  token?: { ok: boolean; status: number; detail: string } | null;
  url?: string; sentBody?: string; unresolved?: string[];
};

// The request-token rule the API applies (TokenResolver.RenderForRequest): no quote, colon, comma or line break
// inside the braces, so a JSON object's own braces are never read as a token.
const REQUEST_TOKEN_RE = /\{\s*([^{}"':,\s][^{}"':,\r\n]*?)\s*\}/g;
function requestTokens(...texts: string[]): string[] {
  const seen = new Map<string, string>();
  for (const text of texts) {
    for (const m of (text ?? '').matchAll(REQUEST_TOKEN_RE)) {
      const tok = m[1].trim();
      if (!seen.has(tok.toLowerCase())) seen.set(tok.toLowerCase(), tok);
    }
  }
  return Array.from(seen.values());
}
// A field whose whole value is one token — "{subject.memberId}" — as against text with a token inside it.
const WHOLE_TOKEN_RE = /^\s*\{[^{}]*\}\s*$/;

// v12.4.16 (#495): every field of the request body, as dotted paths with the raw text that will be sent.
// The request-side mirror of samplePaths: same walk, same depth cap, and the JSON's own key order kept, so the
// Sample values panel never reshuffles while he types. null = the body is not an object we can name fields in
// (not JSON yet, or a GET with no body); the panel then falls back to listing the tokens alone.
type BodyField = { path: string; raw: string; tokens: string[] };
// v12.5.3 (#542): the same normalization ChipEditor.serialize() now applies on the way out, repeated here
// because a body SAVED BEFORE 12.5.3 still carries U+00A0 and must stop being rejected without a re-save.
// Parsing the normalized text is not lenience: U+00A0 is not JSON whitespace, but it is also not what the
// author typed - the browser substituted it for their space. We read what they meant and store what we read.
export const normalizeBodyWhitespace = (s: string) =>
  (s ?? '').replace(/[\u00a0\u202f\u2007]/g, ' ').replace(/\r/g, '');

function bodyFields(body: string, maxDepth = 4): BodyField[] | null {
  const text = normalizeBodyWhitespace(body ?? '').trim();
  if (text.length === 0) return null;
  let root: unknown;
  try { root = JSON.parse(text); } catch { return null; }
  if (root === null || typeof root !== 'object') return null;
  const out: BodyField[] = [];
  const isLeaf = (v: unknown) => v === null || typeof v !== 'object';
  const rawOf = (v: unknown) => (typeof v === 'string' ? v : JSON.stringify(v) ?? '');
  const add = (path: string, v: unknown) => { const raw = rawOf(v); out.push({ path, raw, tokens: requestTokens(raw) }); };
  const walk = (node: unknown, prefix: string, depth: number) => {
    if (node === null || typeof node !== 'object' || depth > maxDepth || out.length > 200) return;
    if (Array.isArray(node)) {
      if (node.length === 0) return;
      const first = `${prefix}[0]`;
      if (isLeaf(node[0])) add(first, node[0]); else walk(node[0], first, depth + 1);
      return;
    }
    for (const [key, child] of Object.entries(node as Record<string, unknown>)) {
      const path = prefix.length === 0 ? key : `${prefix}.${key}`;
      if (isLeaf(child)) add(path, child); else walk(child, path, depth + 1);
    }
  };
  walk(root, '', 0);
  return out;
}

// v12.4.16 (#495): one line of the Sample values panel. A token field is an input he fills; a literal is the same
// row, read-only and tagged, so a value that IS going out can never read as one that vanished.
// v12.5.3 (#544): ONE LINE PER FIELD - label, field, type, format - and the value it will send.
//
// Tushar, 2026-09-20: "what we really need is field, Type, Format. i know in json it is string but knowing
// the type will be easier to convert the format, do not leave chance for errors."
//
// 12.5.2 put the format control on its own row UNDER the value, reasoning that a format is a property of the
// field rather than a second value beside it. That reasoning was fine and the result was not: a body of nine
// fields became eighteen rows, and the type - the thing that DECIDES which formats are even offered - was
// read by typeOf() and shown nowhere. So the row carries all four now, in his order.
//
// TYPE IS READ-ONLY, deliberately. A field's type belongs to the vocabulary (BDR-001 v1.1: entities and
// fields are platform-managed), not to whichever integration happens to send it. "not specified" is the
// honest label when the catalog has none; it is never guessed from the field's NAME, because dateOfService
// and candidate and zipCode are how name-sniffing starts formatting things it should have left alone.
function SampleRow({ label, field, type, title, editable, value, tag, onChange, format }: {
  label: string; field: string; type: string; title: string; editable: boolean; value: string;
  tag?: string; onChange?: (v: string) => void;
  // Present only on a Date or Time field - the only two the wire layer can reshape.
  format?: { type: string; value: string; canonical: string; options: Array<{ fmt: string; eg: string }>; sent: string; onChange: (v: string) => void };
}) {
  return (
    <div className="ct-sample">
      <span className="ct-sample-lab" title={title}>{label}</span>
      <code className="ct-sample-field">{field}</code>
      <span className={`ct-sample-type${type === 'not specified' ? ' is-none' : ''}`}>{type}</span>
      <div className="ct-sample-fmtcell">
        {format ? (
          <select className="ct-fmt-sel" value={format.value} onChange={(e) => format.onChange(e.target.value)}
            title={`This ${format.type} is stored as ${format.canonical} and sent in the shape you choose here.`}>
            {format.options.map((o) => (
              <option key={o.fmt || '(none)'} value={o.fmt}>
                {/* v12.5.3 (#544): the empty option said "(no override - canonical)", which is our word for
                    it and not anyone else's. It now shows THIS field's stored value and says plainly that
                    nothing is done to it. */}
                {o.fmt ? `${o.fmt}  \u2192  ${o.eg}` : `${format.canonical || o.eg}  \u2014  as stored, unchanged`}
              </option>
            ))}
          </select>
        ) : <span className="ct-sample-dash">&mdash;</span>}
      </div>
      <div className="ct-sample-val">
        <input value={value} readOnly={!editable} className={editable ? undefined : 'is-fixed'}
          onChange={editable && onChange ? (e) => onChange(e.target.value) : undefined}
          placeholder="(empty)" spellCheck={false} />
        {/* The whole point of #496: the EXACT string that leaves us, before a call does it for real. Shown
            only when a format actually reshapes the value - an unchanged echo beside the box is noise. */}
        {format && format.sent !== format.canonical
          ? <code className="ct-fmt-preview" title="Exactly what this field will send">{format.sent}</code>
          : null}
        {tag ? <em className="ct-sample-tag">{tag}</em> : null}
      </div>
    </div>
  );
}

function sampleKey(token: string): string {
  let k = canonToken(token).toLowerCase();
  if (k.startsWith('subject.')) k = 'patient.' + k.slice('subject.'.length);
  else if (k.startsWith('request.')) k = 'appointment.' + k.slice('request.'.length);
  return k;
}

// v12.5.3 (#543): the sample this drawer sends must be the CANONICAL value a live call sends, not the spoken
// one a prompt preview shows. Named twin first, then the field's declared type, then the spoken sample - a
// name or a ZIP is identical either way, so most tokens land on the last branch and nothing changes for them.
function wireSampleFor(token: string, type?: string): string {
  const k = sampleKey(token);
  const named = WIRE_SAMPLE_VALUES[k];
  if (named !== undefined) return named;
  const byType = CANONICAL_SAMPLE_BY_TYPE[(type ?? '').toLowerCase()];
  if (byType !== undefined) return byType;
  return SAMPLE_VALUES[k] ?? '';
}
const isOrgToken = (t: string) => /^(organization|tenant)\./i.test(t.trim());

// One result block, used by the token test and by every action test.
function TestResultView({ r }: { r: TestResult }) {
  return (
    <div className={`ct-result ${r.ok ? 'ok' : 'err'}`}>
      {r.token && (
        <div className="ct-result-line">
          {r.token.ok ? <CheckCircleIcon /> : <AlertCircleIcon />}
          <b>{r.token.ok ? 'Token fetched' : 'Token request failed'}</b>
          {r.token.status ? <span className="ct-status">HTTP {r.token.status}</span> : null}
          <span className="ct-result-detail">{r.token.detail}</span>
        </div>
      )}
      {r.stage !== 'token' && (
        <div className="ct-result-line">
          {r.ok ? <CheckCircleIcon /> : <AlertCircleIcon />}
          <b>{r.ok ? 'Called' : 'Failed'}</b>
          {r.status ? <span className="ct-status">HTTP {r.status}</span> : null}
          <span className="ct-result-detail">{r.detail}</span>
        </div>
      )}
      {!r.token && r.stage === 'token' && <div className="ct-result-detail">{r.detail}</div>}
      {r.url ? <div className="ct-result-detail mono">→ {r.url}</div> : null}
      {r.unresolved && r.unresolved.length > 0
        ? <div className="ct-sample-warn">Sent unfilled: {r.unresolved.map((t) => `{${t}}`).join(', ')}</div> : null}
      {r.sentBody ? <><div className="ct-result-sub">Sent body</div><pre className="ct-response">{r.sentBody}</pre></> : null}
      {r.response ? <><div className="ct-result-sub">Response</div><pre className="ct-response">{r.response}</pre></> : null}
    </div>
  );
}

/* ── shared drawer shell ────────────────────────────────────────────────── */
function Drawer({ title, subtitle, children, footer, onClose }: { title: string; subtitle: string; children: ReactNode; footer: ReactNode; onClose: () => void }) {
  return (
    <div className="int-drawer-scrim" onMouseDown={(e) => { if (e.target === e.currentTarget) onClose(); }}>
      <div className="int-drawer" role="dialog" aria-modal="true" aria-label={title}>
        <div className="dw-accent" />
        <div className="dw-head">
          <div><h4>{title}</h4><p>{subtitle}</p></div>
          <button type="button" className="modal-x" onClick={onClose} aria-label="Close"><XIcon /></button>
        </div>
        <div className="dw-body">{children}</div>
        <div className="dw-foot">{footer}</div>
      </div>
    </div>
  );
}

function Field({ label, help, full, children }: { label: string; help?: [string, ReactNode][]; full?: boolean; children: ReactNode }) {
  return <div className={`f${full ? ' full' : ''}`}><label>{label}{help && <HelpTooltip sections={help} />}</label>{children}</div>;
}

/* ── inline icons ───────────────────────────────────────────────────────── */
const S = (p: { children: ReactNode }) => <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={2} strokeLinecap="round" strokeLinejoin="round">{p.children}</svg>;
function PlusIcon() { return <S><path d="M12 5v14M5 12h14" /></S>; }
function XIcon() { return <S><path d="M18 6L6 18M6 6l12 12" /></S>; }
function EditIcon() { return <S><path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7" /><path d="M18.5 2.5a2.1 2.1 0 0 1 3 3L12 15l-4 1 1-4z" /></S>; }
function TrashIcon() { return <S><path d="M3 6h18M8 6V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2M19 6l-1 14a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2L5 6" /></S>; }
function CheckIcon() { return <S><path d="M20 6L9 17l-5-5" /></S>; }
function CheckCircleIcon() { return <S><path d="M9 12l2 2 4-4" /><circle cx="12" cy="12" r="10" /></S>; }
function AlertCircleIcon() { return <S><circle cx="12" cy="12" r="10" /><path d="M12 8v4M12 16h.01" /></S>; }
function AlertTriIcon() { return <S><path d="M10.3 3.9 1.8 18a2 2 0 0 0 1.7 3h17a2 2 0 0 0 1.7-3L13.7 3.9a2 2 0 0 0-3.4 0z" /><path d="M12 9v4M12 17h.01" /></S>; }
function FlagIcon() { return <S><path d="M4 4h16v12H8l-4 4z" /></S>; }
function LockIcon() { return <S><rect x="3" y="11" width="18" height="11" rx="2" /><path d="M7 11V7a5 5 0 0 1 10 0v4" /></S>; }
function BoltIcon() { return <S><path d="M13 2L3 14h9l-1 8 10-12h-9l1-8z" /></S>; }
// v12.4.16 (#515): the hold budget is about elapsed time, so it gets a clock.
function ClockIcon() { return <S><circle cx="12" cy="12" r="9" /><path d="M12 7v5l3 2" /></S>; }
function PlugIcon() { return <S><path d="M10 13a5 5 0 0 0 7 0l3-3a5 5 0 0 0-7-7l-1 1M14 11a5 5 0 0 0-7 0l-3 3a5 5 0 0 0 7 7l1-1" /></S>; }
function MailIcon() { return <S><rect x="2" y="4" width="20" height="16" rx="2" /><path d="M22 7l-10 7L2 7" /></S>; }
function SendIcon() { return <S><path d="M22 2 11 13M22 2l-7 20-4-9-9-4 20-7z" /></S>; }
function SaveIcon() { return <S><path d="M19 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11l5 5v11a2 2 0 0 1-2 2z" /><path d="M17 21v-8H7v8M7 3v5h8" /></S>; }
function DownloadIcon() { return <S><path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4M7 10l5 5 5-5M12 15V3" /></S>; }
function EyeIcon() { return <S><path d="M2 12s3.5-7 10-7 10 7 10 7-3.5 7-10 7-10-7-10-7z" /><circle cx="12" cy="12" r="3" /></S>; }
function EyeOffIcon() { return <S><path d="M17.94 17.94A10.07 10.07 0 0 1 12 20c-6.5 0-10-7-10-7a17.4 17.4 0 0 1 4.06-5.06M9.9 4.24A9.12 9.12 0 0 1 12 4c6.5 0 10 7 10 7a17.7 17.7 0 0 1-2.16 3.19M1 1l22 22M9.5 9.5a3 3 0 0 0 4.24 4.24" /></S>; }

/* ── v12.7.1 (#590): a milliseconds field, local to this screen ─────────────────────────────────────────
   Reliability has a NumberField of its own, but its styles are scoped `.reliability-panel .numfield` and
   this screen is `.integrations-panel`, so importing that component would have rendered an unstyled box.
   The markup and the class names match it deliberately - a tenant moving this number from one screen to the
   other should not have to learn a different control - and `integrations.css` carries the scoped copy.
   NULL IS A REAL VALUE HERE: empty means "not set on this screen", which is what the API stores as null and
   what lets the engine fall back exactly as it did before the split. It is not the same as 0. */
function MsField({ value, onChange, min, max, step }: {
  value: number | null; onChange: (v: number | null) => void; min: number; max: number; step: number;
}) {
  const clamp = (v: number) => (v < min ? min : v > max ? max : v);
  const bump = (dir: number) => onChange(clamp((Number(value) || HOLD_DEFAULT_ACTION_TIMEOUT_MS) + dir * step));
  const secs = value && value > 0 ? `${Number.isInteger(value / 1000) ? value / 1000 : (value / 1000).toFixed(1)} sec` : 'not set';
  return (
    <>
      <span className="nf-sec-top">{secs}</span>
      <div className="numfield">
        <input
          type="text" inputMode="numeric" className="nf-input"
          value={value ?? ''}
          placeholder={String(HOLD_DEFAULT_ACTION_TIMEOUT_MS)}
          onChange={(e) => {
            const raw = e.target.value.replace(/[^0-9]/g, '');
            onChange(raw === '' ? null : clamp(Number(raw)));
          }}
        />
        <div className="nf-labels"><span className="nf-unit">ms</span></div>
        <div className="nf-steppers">
          <button type="button" className="nf-up" onClick={() => bump(1)} aria-label="Increase" tabIndex={-1}><NfChevron up /></button>
          <button type="button" className="nf-down" onClick={() => bump(-1)} aria-label="Decrease" tabIndex={-1}><NfChevron /></button>
        </div>
      </div>
    </>
  );
}
function NfChevron({ up }: { up?: boolean }) {
  return <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={2} strokeLinecap="round" strokeLinejoin="round">{up ? <path d="M6 15l6-6 6 6" /> : <path d="M6 9l6 6 6-6" />}</svg>;
}
